/* eslint-disable react-hooks/exhaustive-deps */
import Constant from '../../../common/constant/Constant';
import Utils from '../../../common/utils/utils';
import { buildItemTagList } from '@/component/formManagement/addField/handler/MasterKnowledgeHandler';
import { isPermissionAddItemTagOfCreateTicket, isModelUnsupportedForTagItem } from '@/component/formManagement/handler/CommonHandler';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { userAtom } from '@/state/atom/userAtom';
import { Box, Checkbox, Chip, FormControlLabel, Popper, Radio, RadioGroup, TextField, Tooltip } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { buildAutoFillTagField } from '../handler/TagFieldHandler';
import { queryFieldChild, getFormById } from '@/service/formManagementService';
import SystemField from '@/common/constant/SystemField';
import _, { cloneDeep } from 'lodash';
import RenderTooltipTitles from './RenderTooltipTitles';
import UnCheckIconWhite from '../../project/settingCategory/UnCheckIconWhite';
import CheckedIcon from '../../project/settingCategory/CheckedIcon';
import DisabelCheckedIcon from '../../project/settingCategory/DisabelCheckedIcon';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import OverflowTooltipContent from '@/component/common/OverflowTooltipContent';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import {
    isShowReasoningEffortField,
    isShowFieldEventTypeChatThread,
    validateShowTagItemEventTypeChatThread,
    getTagItemsByRelatedSystemFieldValue,
    validateShowTagItemEventTrigger,
    validateShowTagItemReasoningEffort,
    isShowFieldAIPDFPageSplitStatus,
    fetchAllMcpServers,
    isShowMCPServerSettingField,
    isShowFieldCallApiTarget,
    validateShowTagItemTriggerCondition,
    validateShowTagItemExecutionScope,
    buildCallHandlerTagValue,
    triggerValueWhenFieldHasSubscriptionUpdate,
    buildAiOperatorPromptTagValue,
} from '../../ticketList/handler/KnowledgeTicketHandler';
import { isShowKibanaAnalysisField } from '@/component/chatAI/element/InputChatAiGroupButtons/handler/MCPServerDropdownHandler';
import { projectListInCorporationAtom } from '@/state/atom/projectAtom';
import PropTypes from 'prop-types';
import { getCorporationById } from '@/service/organizationService';
import { getProjectById } from '@/service/projectService';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import TimezoneConstant from '@/common/constant/TimezoneConstant';
import TimezoneUtils from '@/common/utils/timezoneUtils';
import { setPanelSelector } from '@/state/selector/panelSelector';
import { openShareLinkTicket } from '@/component/chatThread/handler/MessageHandler';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import localStorageUtil from '@/common/utils/localStorageUtil';
import OpenAiUtil from '@/common/utils/OpenAiUtil';
import { LOCAL_MCP_USER_PREFIX } from '@/component/mcpCatalog/McpCatalogConstant';
import { parseLocalMcpScope } from '@/common/utils/mcpUtils';
import { trI18n } from '@/common/utils/trI18n';
import { tr, trTag } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { NON_TRANSLATABLE_TAG_SYS_FIELDS } from '@/common/utils/translationUtils';
import { getCallHandlerDisplayName } from '@/common/utils/DrilldownDisplayUtils';


MenuTagInPutBase.propTypes = {
    API: PropTypes.any,
    isNotAuthen: PropTypes.any,
    listFieldEdited: PropTypes.any,
    setListFieldEdited: PropTypes.any,
    name: PropTypes.any,
    userListOfProject: PropTypes.any,
    detailTicket: PropTypes.any,
    data: PropTypes.any,
    projectDetail: PropTypes.any,
    isProjectManager: PropTypes.any,
    isEdited: PropTypes.bool,
    hasEditFieldPermissions: PropTypes.bool,
    defaultValue: PropTypes.any,
    fieldListDefaultData: PropTypes.any,
    setValue: PropTypes.any,
    setTagListValue: PropTypes.any,
    setIsTagList: PropTypes.any,
    setAutoFillObject: PropTypes.any,
    viewFromProjectOfEscalateTicket: PropTypes.any,
    clearErrors: PropTypes.func,
    setOptionsOfTagField: PropTypes.func,
    affiliationProjectOfTicket: PropTypes.any,
};

// Component to render disabled chip with tooltip that only shows when text overflows
const DisabledChipWithTooltip = ({ label, tagProps }) => {
    const textRef = React.useRef(null);
    const [isShowTooltip, setIsShowTooltip] = React.useState(false);

    // Validate and provide default value for label to handle null/undefined cases
    const safeLabel = label || '';

    const updateTooltipVisibility = React.useCallback(() => {
        if (textRef.current) {
            // Check if text content exceeds visible width to determine if tooltip should be shown
            const isOverflowing = textRef.current.scrollWidth > textRef.current.clientWidth;
            setIsShowTooltip(isOverflowing);
        }
    }, []);

    React.useLayoutEffect(() => {
        updateTooltipVisibility();
        window.addEventListener('resize', updateTooltipVisibility);

        return () => {
            window.removeEventListener('resize', updateTooltipVisibility);
        };
    }, [updateTooltipVisibility, safeLabel]);

    const chipWrapperStyle = {
        display: 'inline-block',
        maxWidth: '100%'
    };

    const chipLabelStyle = {
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block'
    };

    return (
        <Tooltip
            title={safeLabel}
            disableHoverListener={!isShowTooltip}
            placement="top"
            arrow
        >
            <span style={chipWrapperStyle}>
                <Chip
                    label={
                        <span ref={textRef} style={chipLabelStyle}>
                            {safeLabel}
                        </span>
                    }
                    {...tagProps}
                    onDelete={null}
                />
            </span>
        </Tooltip>
    );
};

DisabledChipWithTooltip.propTypes = {
    label: PropTypes.string,
    tagProps: PropTypes.object.isRequired,
};

// Component to render call handler value with overflow tooltip (similar to EllipsisTag in AssigneeFieldCommonUI)
const OverflowTooltipValue = ({ title }) => {
    const textRef = React.useRef(null);
    const [isOverflow, setIsOverflow] = React.useState(false);

    const checkOverflow = React.useCallback(() => {
        const el = textRef.current;
        if (!el) return;
        requestAnimationFrame(() => {
            setIsOverflow(el.scrollWidth > el.clientWidth);
        });
    }, []);

    React.useEffect(() => {
        checkOverflow();
        const observer = new ResizeObserver(() => checkOverflow());
        if (textRef.current) {
            observer.observe(textRef.current);
        }
        return () => observer.disconnect();
    }, [checkOverflow, title]);

    const content = (
        <span
            ref={textRef}
            style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'block',
                maxWidth: '100%',
                fontSize: '14px',
                color: '#2E3138',
                lineHeight: '40px',
                pointerEvents: 'auto'
            }}
        >
            {title}
        </span>
    );

    if (isOverflow) {
        return (
            <Tooltip title={title} placement="top" arrow>
                {content}
            </Tooltip>
        );
    }

    return content;
};

OverflowTooltipValue.propTypes = {
    title: PropTypes.string,
};

const getTagItemIdListFromDefaultValue = (defaultValue) => {
    if (Utils.isEmptyArray(defaultValue)) return [];

    let listDefaultValue = [];
    defaultValue.forEach(tagSelected => {
        if (typeof tagSelected === 'string') {
            listDefaultValue.push(tagSelected);
        } else if (
            typeof tagSelected === 'object' &&
            !Utils.isEmptyObject(tagSelected)
        ) {
            listDefaultValue.push(tagSelected.value);
        }
    });

    return listDefaultValue;
}

const TELEPHONE_FIELDS_SHOW_BLANK_ON_EMPTY = [
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.REVIEW_STATUS,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.FOLLOW_UP_STATUS
];

const getSelectDefaultItemBySysField = (sysField) => {
    if (TELEPHONE_FIELDS_SHOW_BLANK_ON_EMPTY.includes(sysField)) {
        return {
            ...Constant.FIELD_UI_SELECT_DEFAULT_ITEM,
            title: ''
        };
    }

    return Constant.FIELD_UI_SELECT_DEFAULT_ITEM;
};

export default function MenuTagInPutBase(props) {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();
    const {
        setAIAutoSelectedData,
        aiAutoSelectedData,
        clearErrors,
        detailTicket,
        formsInCorporation,
        fieldsInCorporation,
        isDuplicate,
        sdautoSelectedData,
        setSdautoSelectedData,
        aiTelephoneSelectedData,
        setAITelephoneSelectedData
    } = { ...props };
    let resetRelatedField = []
    const addNewPanel = useSetRecoilState(setPanelSelector);

    const [validateError, setValidateError] = useState(props.data?.error);
    const [tagList, setTagList] = useState([]);
    const [tagValue, setTagValue] = useState([]);
    const [enableShowMore, setEnableShowMore] = useState(false);
    const [showAddItemInput, setShowAddItemInput] = useState(false);
    const [numOfRecordDisplay, setNumOfRecordDisplay] = useState(props.data.structure.recordNumber);
    const [firstRender, setFirstRender] = useState(true)
    const [isLoadingInput, setIsLoadingInput] = useState(false)
    const [showMCPServerField, setShowMCPServerField] = useState(null);
    const [showKibanaAnalysisField, setShowKibanaAnalysisField] = useState(null);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [defaultIndexChecked, setDefaultIndexChecked] = useState(
        !props.data.structure.isAutoFill ||
            props.data.structure.settingSelectItem !==
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL
            ? 0
            : ''
    );
    const [mustCleaningTagList, setMustCleaningTagList] = useState(false);
    const previousChatGptModelInReasoningField = useRef('');
    const isInitializedReasoningModelRef = useRef(false);
    const INITIAL_ITEM_PERSONAL_CONNECTOR_SERVICES = [
        {
            value: Constant.PERSONAL_CONNECTOR_COMMON_ID.DROPBOX,
            title: Utils.serverNameWithPrefix(
                Constant.PERSONAL_CONNECTOR_SERVICE_NAME.DROPBOX,
                Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL
            ),
            sysField: Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
            isShow: true,
            isShowItemInTicket: true
        },
        {
            value: Constant.PERSONAL_CONNECTOR_COMMON_ID.GMAIL,
            title: Utils.serverNameWithPrefix(
                Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GMAIL,
                Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL
            ),
            sysField: Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
            isShow: true,
            isShowItemInTicket: true
        },
        {
            value: Constant.PERSONAL_CONNECTOR_COMMON_ID.GOOGLE_CALENDAR,
            title: Utils.serverNameWithPrefix(
                Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GOOGLE_CALENDAR,
                Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL
            ),
            sysField: Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
            isShow: true,
            isShowItemInTicket: true
        },
        {
            value: Constant.PERSONAL_CONNECTOR_COMMON_ID.GOOGLE_DRIVE,
            title: Utils.serverNameWithPrefix(
                Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GOOGLE_DRIVE,
                Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL
            ),
            sysField: Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
            isShow: true,
            isShowItemInTicket: true
        },
        {
            value: Constant.PERSONAL_CONNECTOR_COMMON_ID.MICROSOFT_TEAM,
            title: Utils.serverNameWithPrefix(
                Constant.PERSONAL_CONNECTOR_SERVICE_NAME.MICROSOFT_TEAM,
                Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL
            ),
            sysField: Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
            isShow: true,
            isShowItemInTicket: true
        },
        {
            value: Constant.PERSONAL_CONNECTOR_COMMON_ID.OUTLOOK_CALENDAR,
            title: Utils.serverNameWithPrefix(
                Constant.PERSONAL_CONNECTOR_SERVICE_NAME.OUTLOOK_CALENDAR,
                Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL
            ),
            sysField: Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
            isShow: true,
            isShowItemInTicket: true
        },
        {
            value: Constant.PERSONAL_CONNECTOR_COMMON_ID.OUTLOOK_GMAIL,
            title: Utils.serverNameWithPrefix(
                Constant.PERSONAL_CONNECTOR_SERVICE_NAME.OUTLOOK_GMAIL,
                Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL
            ),
            sysField: Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
            isShow: true,
            isShowItemInTicket: true
        },
        {
            value: Constant.PERSONAL_CONNECTOR_COMMON_ID.SHAREPOINT,
            title: Utils.serverNameWithPrefix(
                Constant.PERSONAL_CONNECTOR_SERVICE_NAME.SHAREPOINT,
                Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL
            ),
            sysField: Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
            isShow: true,
            isShowItemInTicket: true
        }
    ].sort((a, b) => a.title.localeCompare(b.title));

    const isAddNewTicket = !props?.detailTicket;
    const isDisableField =
        Number(props.data.structure.publicForCustomer) === Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW ||
        props.viewFromProjectOfEscalateTicket ||
        !Utils.isEmptyString(props.detailTicket?.deletedAt) ||
        props.hasEditFieldPermissions === false ||
        (
            { ...props }?.data?.sysField === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING_TARGET &&
            !isShowFieldCallApiTarget(sdautoSelectedData)
        )

    //state using for query tag items paginate.
    const [nextToken, setNextToken] = useState(null);
    //listen scroll event list tag items in tag field and load more items.

    const PopperComponentMemo = useMemo(() => {
        let fieldId = props?.data?.id
        return ({ style, ...props }) => (
            <Popper {...props} style={{ ...style }} className={`selectDrop tag-field-multi-select ${fieldId}`}  />
        );
    }, []);

    const getDefaultChecked = () => {
        let indexOfSelectedTag = null; // don't check default value for radio tag field.
        if (!Utils.isEmptyArray(tagValue) && !tagValue.some(i => i?.value === null)) {
            tagList?.forEach((tag, index) => {
                if (tag?.value === tagValue[0]?.value) {
                    indexOfSelectedTag = index;
                }
            });
        }
        return indexOfSelectedTag;
    };

    // Return the translated tag item title for display; keep original for identifier fields and empty title
    const getDisplayTitle = item => {
        const title = item?.title || '';
        if (!title) return title;
        // telephone_call_handler value is either a USER id (never translated) or a KNOWLEDGE id
        // (AI Operator, system-generated name that must be translated) — checked before the
        // generic NON_TRANSLATABLE_TAG_SYS_FIELDS rule below, which would otherwise force
        // "keep as-is" for both cases since CALL_HANDLER is listed there for the USER case.
        // Safe to call unconditionally: getCallHandlerDisplayName is idempotent (tr() on an
        // already-translated string is a no-op lookup), so this stays correct even if the
        // upstream tagList/tagValue source changes to stop pre-translating the title.
        if (props?.data?.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER) {
            return getCallHandlerDisplayName(item?.value, title);
        }
        if (NON_TRANSLATABLE_TAG_SYS_FIELDS.includes(props?.data?.sysField)) {
            return title;
        }
        // Project items (identifier, group 3) are never translated — e.g. BUSINESS_APP_USE_RANGE project options
        if (Utils.getPrefixOfId(item?.value) === Constant.ID_PREFIX.PROJECT) {
            return title;
        }
        // AI Operator Prompt Knowledge title: translation only, no "(original)" suffix
        if (props?.data?.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.AI_OPERATOR_PROMPT) {
            return tr(title);
        }
        return trTag(title);
    };

    const [originItemList, setOriginItemList] = useState([]);
    const [errorsAddItem, setErrorsAddItem] = useState('');

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);

    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);

    //common project atom
    const projectsInCorporation = useRecoilValue(projectListInCorporationAtom)

    // common projectInuse state
    const projectDetail = props?.projectDetail;
    const isProjectManager = props?.isProjectManager;

    let userListOfProject = props?.userListOfProject;

    const [isPermissionAddItemTag, setIsPermissionAddItemTag] = useState(false);
    let argsCommon = {
        API: props?.API,
        isNotAuthen: props?.isNotAuthen,
        tagField: props.data,
        userDetail: userDetail,
        corporationDetail: corporationDetail,
        projectDetail: projectDetail,
        userListOfProject: userListOfProject,
        originItemList: originItemList,
        setOriginItemList: setOriginItemList,
        // listProjectOfUser: listProjectOfUser,
        isPermissionAddItemTag: isPermissionAddItemTag,
        setIsPermissionAddItemTag: setIsPermissionAddItemTag,
        isProjectManager,
        tagList,
        setTagList,
        tagValue,
        setTagValue,
        firstRender,
        defaultValue: Utils.isEmpty(props.defaultValue)
            ? []
            : Utils.convertJSONDataToObject(props.defaultValue),
        setDefaultIndexChecked
    };

    useEffect(() => {
        // check permission add item tag when create ticket
        isPermissionAddItemTagOfCreateTicket(argsCommon);
    }, [props.data]);

    // Handle subscription updates for telephone fields (CALL_HANDLER, AI_OPERATOR_PROMPT)
    useEffect(() => {
        if (!props?.subscriptionFieldValue) return;

        const sysField = props?.data?.sysField;
        // Whitelist listen subscription
        const SUBSCRIPTION_SUPPORTED_FIELDS = [
            TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER,
            TelephoneConstant.TELEPHONE.SYSTEM_FIELD.AI_OPERATOR_PROMPT,
        ];
        if (!SUBSCRIPTION_SUPPORTED_FIELDS.includes(sysField)) return;

        const updateFieldFromSubscription = async () => {
            const result = await triggerValueWhenFieldHasSubscriptionUpdate(
                props.subscriptionFieldValue,
                sysField,
                userDetail,
                corporationDetail
            );

            if (result === null) return;

            setTagList([...result]);
            setTagValue([...result]);
            props.setValue(props?.name, [...result]);
        };

        updateFieldFromSubscription();
    }, [props?.subscriptionFieldValue]);

    const formatTagList = fieldTagList => {
        let tagItemList = [];
        for (const field of fieldTagList) {
            let fieldStructure = Utils.convertJSONDataToObject(field?.structure);
            const noOfItem = Number(fieldStructure.no);
            const isShowItemInTicket = fieldStructure.isShowItemInTicket ? true : false;
            const hasOwnIsShow = field?.hasOwnProperty('isShow')
            let isShow = true
            if (hasOwnIsShow && field?.isShow === false) {
                isShow = false;
            }

            tagItemList.push({
                title: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.name),
                value: field.id,
                originalSysField: field?.originalSysField,
                no: noOfItem,
                hitNumber: field.hitNumber,
                isShowItemInTicket,
                sysField: field?.sysField,
                isShow
            });
        }

        // sort item list by order
        tagItemList = tagItemList.sort((a, b) => {
            return a.no - b.no;
        });
        return tagItemList;
    };

    const sortItemWithHitNumber = (firstItem, secondItem) => {
        if (firstItem.hitNumber > secondItem.hitNumber) {
            return -1;
        }
        if (firstItem.hitNumber < secondItem.hitNumber) {
            return 1;
        }
        if (firstItem.hitNumber === secondItem.hitNumber) {
            if (Number(firstItem.no) < Number(secondItem.no)) {
                return -1;
            } else {
                return 1;
            }
        }
        return 0;
    };


    useEffect(() => {
        props.register(props.name);
        let tagField = argsCommon.tagField;

        const thisFieldInfo = props?.data
        const SYSTEM_FIELDS_NEED_LISTEN_EFFECT = [
            Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.AND,
            Constant.AI_AUTO.SYSTEM_FIELD.OR,
            Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE,
            Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER,
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER,
            Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL,
            Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
        ]
        switch (tagField.structure.settingSelectItem) {
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE:
                buildItemTagList(argsCommon,null,{
                    userDetail: userDetail,
                    projectDetail: projectDetail,
                    corporationDetail: corporationDetail
                });
                break;
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL:
                buildAutoFillTagField(argsCommon);
                break;
            default:
                // LinhNV02 said: not queryFieldChild with sysField  AND, OR, EXCLUDE because have not tags on server
                if ([
                    Constant.AI_AUTO.SYSTEM_FIELD.AND,
                    Constant.AI_AUTO.SYSTEM_FIELD.OR,
                    Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE,
                ].includes(thisFieldInfo?.sysField)) {
                    return;
                }

                (async () => {
                    if (thisFieldInfo?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING) {
                        let isNewTicket = (isAddNewTicket || isDuplicate);
                        let orgCheckSettingData = corporationDetail;
                        if (!isNewTicket && corporationDetail?.id !== detailTicket?.affiliationOrganization && detailTicket?.affiliationOrganization) {
                            orgCheckSettingData = await getCorporationById(null, detailTicket?.affiliationOrganization);
                        }
                        const shouldShowMCPField = isShowMCPServerSettingField(
                            orgCheckSettingData,
                            detailTicket,
                            isNewTicket
                        );

                        let listMcpServerOptions = [];
                        if (shouldShowMCPField) {
                            const corporationId = (isAddNewTicket || isDuplicate) ? corporationDetail?.id : detailTicket?.affiliationOrganization;
                            const corporationContractType = (isAddNewTicket || isDuplicate) ? corporationDetail?.contractType : props?.corporationAffiliationTicket?.contractType;
                            const projectId = (isAddNewTicket || isDuplicate) ? projectDetail?.id : detailTicket?.affiliationProject;
                            const userId = (isAddNewTicket || isDuplicate) ? userDetail?.id : detailTicket?.creator;


                            listMcpServerOptions = tagList;
                            if (Utils.isEmptyArray(tagList)) {
                                let listDefaultValue = getTagItemIdListFromDefaultValue(Utils.convertJSONDataToObject(props?.defaultValue));
                                setIsLoadingInput(true);
                                try {
                                    const listMCPServers = await fetchAllMcpServers(corporationId, corporationContractType, projectId, userId, listDefaultValue);
                                    listMcpServerOptions = listMCPServers.map((server, idx) => ({
                                        title: server.name || '',
                                        value: server.id,
                                        no: idx,
                                        hitNumber: idx,
                                        isShowItemInTicket: true,
                                        sysField: thisFieldInfo?.sysField,
                                        isShow: server?.isShow
                                    }));
                                } catch (err) {
                                    console.error('Error loading MCP servers:', err);
                                    listMcpServerOptions = [];
                                }
                                // comment personal connector
                                // listMcpServerOptions = [...listMcpServerOptions, ...INITIAL_ITEM_PERSONAL_CONNECTOR_SERVICES];
                                listMcpServerOptions = [...listMcpServerOptions];

                                setTagList([...listMcpServerOptions]);
                                setIsLoadingInput(false);
                            }
                        }
                    
                        if (props.defaultValue) {
                            const defaultValue = Utils.convertJSONDataToObject(props.defaultValue);
                            let resultValue = defaultValue.some(v => typeof v === "object")
                                ? defaultValue
                                : listMcpServerOptions.filter(item => defaultValue.includes(item.value));
                            if (isDuplicate && projectDetail?.id !== detailTicket?.affiliationProject) {
                                resultValue = [];
                            }
                            setTagValue([...resultValue]);
                            props.setValue(props?.name, [...resultValue]);
                        } else {
                            setTagValue([]);
                            props.setValue(props?.name, []);
                        }
                        return;
                    }

                    if(thisFieldInfo?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_APPLICABLE_PHONE_NUMBER) {
                        let isNewTicket = (isAddNewTicket || isDuplicate);
                        let projectForCheckPhoneApplicable = projectDetail;
                        if (!isNewTicket && projectDetail?.id !== detailTicket?.affiliationProject && props?.affiliationProjectOfTicket) {
                            projectForCheckPhoneApplicable = props?.affiliationProjectOfTicket;
                        }

                        const projectSetting = Utils.convertJSONDataToObject(projectForCheckPhoneApplicable?.projectSetting);
                        const telephoneAgentSetting = projectSetting?.telephoneAgentSetting;
                        if (!Utils.isEmptyArray(telephoneAgentSetting?.phoneNumbers)) {
                            let listNumer = telephoneAgentSetting?.phoneNumbers?.map(phone => {
                                return {
                                    title: `+${phone.tel}`,
                                    value: `+${phone.tel}`,
                                    isShowItemInTicket: true,
                                    sysField: thisFieldInfo?.sysField,
                                    isShow: true
                                };
                            });
                            setTagList([...listNumer]);

                            if(props.defaultValue) {
                                const defaultValue = Utils.convertJSONDataToObject(props.defaultValue);
                                if(!Utils.isEmptyArray(defaultValue)) {
                                    let listTagValue = listNumer.filter(item => defaultValue.includes(item.value) || defaultValue[0]?.value === item?.value);
                                    if (isDuplicate && projectDetail?.id !== detailTicket?.affiliationProject) {
                                        listTagValue = [];
                                    }
                                    setTagValue([...listTagValue]);
                                    props.setValue(props?.name, [...listTagValue]);
                                }
                            }else{
                                setTagValue([]);
                                props.setValue(props?.name, []);
                            }
                        }

                        return

                    }
                    
                    // Handle CALL_HANDLER field - use shared helper function
                    if (thisFieldInfo?.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER) {
                        if (props.defaultValue) {
                            const defaultValue = Utils.convertJSONDataToObject(props.defaultValue);
                            
                            if (!Utils.isEmptyArray(defaultValue)) {
                                const value = defaultValue[0];
                                const handlerValue = typeof value === 'string' ? value : value?.value;
                                
                                if (!handlerValue) {
                                    setTagList([]);
                                    setTagValue([]);
                                    props.setValue(props?.name, []);
                                    return;
                                }

                                const callHandlerOptions = await buildCallHandlerTagValue(
                                    handlerValue,
                                    thisFieldInfo?.sysField,
                                    userDetail
                                );
                                
                                setTagList([...callHandlerOptions]);
                                setTagValue([...callHandlerOptions]);
                                props.setValue(props?.name, [...callHandlerOptions]);
                                return;
                            }
                        }
                        
                        // No defaultValue, set empty
                        setTagList([]);
                        setTagValue([]);
                        props.setValue(props?.name, []);
                        return;
                    }

                    // Handle AI_OPERATOR_PROMPT field - fetch data based on defaultValue
                    if (thisFieldInfo?.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.AI_OPERATOR_PROMPT) {
                        if (props.defaultValue) {
                            const defaultValue = Utils.convertJSONDataToObject(props.defaultValue);
                            const operatorPromptOptions = await buildAiOperatorPromptTagValue(
                                defaultValue,
                                thisFieldInfo?.sysField,
                                corporationDetail
                            );
                            setTagList([...operatorPromptOptions]);
                            setTagValue([...operatorPromptOptions]);
                            props.setValue(props?.name, [...operatorPromptOptions]);
                        }
                        return; // Skip queryFieldChild
                    }
                    
                // HERE
                queryFieldChild(
                    props?.API,
                    props.data.affiliationOrganization,
                    props.data.id,
                    props.data,
                    nextToken,
                    props?.defaultValue,
                    true,
                    projectDetail?.id
                ).then(result => {
                    setNextToken(result?.nextToken || null);
                    result = result?.fieldChildList || result

                    // ai auto event field. in here, it's form active ai auto event. we don't need query field child. Because, it doesn't have children.
                    if (thisFieldInfo?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE)
                        return result;

                    const systemTagChildList = SystemField.filter(
                        item =>
                            item.usage === Constant.FORM_USAGE.TAG &&
                            item.affiliationField === props.data.id
                    );
                    let tagItemListByFilter = [];
                    if (!Utils.isEmptyArray(result) && Array.isArray(result)) {
                        result.forEach(item => {
                            let structure = Utils.isEmpty(item.structure)
                                ? {}
                                : Utils.convertJSONDataToObject(item.structure);
                            if (structure.isShowItemInTicket || Utils.isEmptyObject(structure)) {
                                tagItemListByFilter.push(item);
                            }
                        });
                    }

                    const tagChildList = !Utils.isEmptyArray(tagItemListByFilter)
                        ? tagItemListByFilter.concat(systemTagChildList)
                        : systemTagChildList;

                    let resFormatTagList = formatTagList(tagChildList);
                    let displayOrder = props.data?.structure?.displayOrder;
                    let tagListSorted = [];

                    /**
                     * filter items by project type. and setting on funcs
                     */
                    let fullAiAutoTicketTypeOptions = resFormatTagList
                    switch (thisFieldInfo?.sysField) {
                        case Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE:
                            const TICKET_TYPES_FOR_DESK_OFF_PROJECT = [
                                Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TASK,
                                Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.KNOWLEDGE,
                                Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TELEPHONE
                            ];
                            

                            const { aiAutoProjectDetail, aiAutoCorporationDetail } = getQueryParamsAIAuto();
                            if (Utils.isPublicOffDeskOff(aiAutoProjectDetail)) {
                                resFormatTagList = _.filter(resFormatTagList, form =>
                                    _.includes(TICKET_TYPES_FOR_DESK_OFF_PROJECT, form?.sysField)
                                );
                            }
                            if (
                                !Utils.isEnableCreateEmailTicketMode(
                                    aiAutoCorporationDetail,
                                    aiAutoProjectDetail
                                )
                            ) {
                                resFormatTagList = _.filter(resFormatTagList, form => {
                                    return (
                                        form?.sysField !==
                                        Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL
                                    );
                                });
                            }
                            if (!Utils.isEnableSettingTelephoneAgent(corporationDetail)) {
                                resFormatTagList = _.filter(resFormatTagList, form => {
                                    return (
                                        form?.sysField !==
                                        Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TELEPHONE
                                    );
                                });
                            }
                            break;
                        case Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER:
                            if (!Utils.isEnableSettingTelephoneAgent(corporationDetail)) {
                                resFormatTagList = resFormatTagList.filter(tag => {
                                    return tag.sysField !== Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CALL_COMPLETED
                                });
                            }
                            break;
                        case Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE: {
                            const ownerProjectDetail =
                                props?.affiliationProjectOfTicket || projectDetail;
                            if (
                                Utils.isSystemFormAITelephonePrompt(props?.parentForm) ||
                                Utils.isSystemFormAIAssistantPrompt(props?.parentForm) ||
                                Utils.isSystemFormAITrainingPrompt(props?.parentForm)
                            )
                                resFormatTagList = resFormatTagList.map(tagItem => {
                                    if (
                                        tagItem?.sysField ===
                                        Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE_EXTERNAL
                                    ) {
                                        return {
                                            ...tagItem,
                                            isShow: validateShowTagItemExecutionScope(
                                                tagItem,
                                                ownerProjectDetail
                                            )
                                        };
                                    }
                                    return tagItem;
                                });
                            break;
                        }
                        case Constant.SYSTEM_FIELD.AI_PROMPT_APPLICATION_TARGET:{
                            if(Utils.isSystemFormKBoardPrompt(props?.parentForm)){
                                resFormatTagList = resFormatTagList.filter(
                                    i =>
                                        i?.sysField ===
                                        Constant.AI_SYSTEM_FIELD_TARGET_OPTION_TAGS.INTERNAL
                                );
                            }
                            break
                        }
                        default:
                    }

                    switch (displayOrder) {
                        case Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER:
                            tagListSorted = resFormatTagList.sort(sortItemWithHitNumber);
                            break;
                        case Constant.DISPLAY_ORDER_TAG_FIELD.DICTIONARY_ORDER:
                            tagListSorted = resFormatTagList.sort((a, b) => {
                                let nameA = a.title;
                                let nameB = b.title;
                                return nameA.localeCompare(nameB);
                            });
                            break;
                        case Constant.DISPLAY_ORDER_TAG_FIELD.CUSTOMISE:
                        default:
                            tagListSorted = resFormatTagList.sort((item1, item2) => {
                                return item1.no - item2.no;
                            });
                            break;
                    }

                    // Filter reasoning_effort options based on selected chatgpt_model
                    if (thisFieldInfo?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT) {
                        tagListSorted = tagListSorted.map(tagItem => {
                            return { ...tagItem, isShow: validateShowTagItemReasoningEffort(tagItem, aiAutoSelectedData) };
                        });
                    }

                    // Filter trigger condition options for AI Telephone form based on prompt type
                    if (
                        thisFieldInfo?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION &&
                        Utils.isSystemFormAITelephonePrompt(props?.parentForm)
                    ) {
                        tagListSorted = tagListSorted.map(tagItem => {
                            return {
                                ...tagItem,
                                isShow: validateShowTagItemTriggerCondition(tagItem, aiTelephoneSelectedData)
                            };
                        });
                    }

                    setTagList(_.unionBy([...tagListSorted], 'value'));
                    // when we have not been determined gpt model Because load gpt model later. we need reload to cleaning tag list to hidden reasoning item don't use for model. 
                    if (
                        Utils.isEmptyArray(tagList) &&
                        thisFieldInfo?.sysField ===
                            Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT &&
                       Utils.isEmptyObject(aiAutoSelectedData[Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL])
                    ) {
                        setMustCleaningTagList(true);
                    }
                    if ([...tagListSorted].length > 0 && props?.setIsTagList) {
                        props?.setIsTagList(true);
                    }

                    // single choice and multiple choice select fields will select a default empty item. <Constant.FIELD_UI_SELECT_DEFAULT_ITEM>
                    if (
                        props.data.structure.optionType ===
                            Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE
                    ) {
                        const defaultSelectItem = getSelectDefaultItemBySysField(
                            thisFieldInfo?.sysField
                        );
                        let listOptionItemTagField = [...tagListSorted]

                        if (
                            !props.data.structure.isMultiple &&
                            ![
                                Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL,
                                Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT,
                                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER,
                                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALLER_LANGUAGE,
                                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.RECEIVER_LANGUAGE,
                                Constant.SYSTEM_FIELD.EXECUTION_TIMEZONE, // TZL-001: do not prepend an empty item (field is required, has a default)
                            ].includes(thisFieldInfo?.sysField)
                        ) {
                            listOptionItemTagField = [
                                defaultSelectItem,
                                ...tagListSorted
                            ];
                        }
                        if (thisFieldInfo?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL && isAddNewTicket) {
                            let corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
                            const supportedIds = corporationSetting?.listChatGptModel
                                ?.filter(item => item.status === Constant.CHAT_GPT_MODEL_STATUS.SUPPORT)
                                ?.map(item => item.id.toUpperCase()) || [];

                            listOptionItemTagField = listOptionItemTagField.filter(
                                item => supportedIds.includes(item.title.toUpperCase()) || item.title === Constant.NO_PREFERENCE
                            );
                        }

                        if (![
                                Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL,
                                Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT,
                                Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING_TARGET,
                            ].includes(thisFieldInfo?.sysField)
                        ) {
                            setTagList([...listOptionItemTagField]);
                        }

                        if(
                            !props.data.structure.isMultiple &&
                            ![
                                Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL,
                                Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT,
                                Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING_TARGET,
                                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER,
                                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALLER_LANGUAGE,
                                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.RECEIVER_LANGUAGE,
                                Constant.SYSTEM_FIELD.EXECUTION_TIMEZONE, // TZL-001: do not auto-set empty (default is handled in a separate case below)
                            ].includes(thisFieldInfo?.sysField)
                        ){
                            setTagValue([defaultSelectItem]);
                        }
                        switch (thisFieldInfo?.sysField) {
                            case Constant.SYSTEM_FIELD.AI_TELEPHONE_REALTIME_MODEL: {
                                const uniqueListOptions = listOptionItemTagField.filter(
                                    (item, index, self) => {
                                        if (
                                            item?.title !== Constant.NO_PREFERENCE &&
                                            TelephoneConstant.UNSUPPORTED_REALTIME_MODELS.includes(item.title)
                                        ) {
                                            return false;
                                        }
                                        return (
                                            index === self.findIndex(t => t.value === item.value)
                                        );
                                    }
                                );
                                setTagList(uniqueListOptions);

                                // Set default option when creating new ticket (no defaultValue)
                                // or when switching forms (defaultValue exists but has no match in current form's options)
                                if (isAddNewTicket || isDuplicate) {
                                    const parsedDefaultValue = Utils.convertJSONDataToObject(props?.defaultValue);
                                    const hasValidDefaultValue = !Utils.isEmptyArray(parsedDefaultValue) &&
                                        parsedDefaultValue.some(dv => {
                                            const dvValue = typeof dv === 'string' ? dv : dv?.value;
                                            return uniqueListOptions.some(opt => opt.value === dvValue && opt.value !== null);
                                        });

                                    if (hasValidDefaultValue) {
                                        // defaultValue is valid for this form — let the common defaultValue block below handle it
                                        break;
                                    }

                                    // No valid default — set gpt-realtime-2.1-mini as default and return early
                                    // to prevent the common defaultValue block from overwriting with empty
                                    const defaultRealtimeModelTitle = TelephoneConstant.SYSTEM_FIELD_LABEL.AI_TELEPHONE_REALTIME_MODEL_GPT_REALTIME_2_1_MINI;
                                    const defaultRealtimeOption = uniqueListOptions.find(
                                        item => item?.title === defaultRealtimeModelTitle
                                    );
                                    if (defaultRealtimeOption) {
                                        setTagValue([defaultRealtimeOption]);
                                        props.setValue(props?.name, [defaultRealtimeOption]);
                                        return;
                                    }
                                }
                                break;
                            }
                            case Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL: {
                                const corporationSetting = Utils.convertJSONDataToObject(
                                    corporationDetail?.corporationSetting
                                );
                                const uniqueListOptions = listOptionItemTagField.filter(
                                    (item, index, self) => {
                                        if (
                                            item?.title !== Constant.NO_PREFERENCE &&
                                            checkModelUnsupport(
                                                item.title,
                                                corporationSetting?.listChatGptModel
                                            )
                                        ) {
                                            return false;
                                        }
                                        return (
                                            index === self.findIndex(t => t.value === item.value)
                                        );
                                    }
                                );
                                setTagList(uniqueListOptions);

                                // Only add default state when creating new.
                                if (
                                    detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT &&
                                    Utils.isEmptyArray(
                                        Utils.convertJSONDataToObject(props?.defaultValue)
                                    )
                                ) {
                                    let gptModelOfCorp = getValueTagChatGPTModelDefault([
                                        ...tagListSorted
                                    ]);
                                    setTagValue([gptModelOfCorp]);
                                    //push default model to state, to checking display reasoning field if gpt-model default is gpt-5
                                    setAIAutoSelectedData(prev => {
                                        return {
                                            ...prev,
                                            [Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL]: [
                                                gptModelOfCorp
                                            ]
                                        };
                                    });
                                    if (setAITelephoneSelectedData) {
                                        setAITelephoneSelectedData(prev => {
                                            return {
                                                ...prev,
                                                [Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL]: [
                                                    gptModelOfCorp
                                                ]
                                            };
                                        });
                                    }
                                }
                                break;
                            }
                            case Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT: {
                                // Use filtered tagListSorted instead of resFormatTagList
                                let gptModelOfCorp = getValueTagChatGPTModelDefault([
                                        ...tagListSorted
                                    ], true);
                                const defaultReasoningOption = tagListSorted?.find(
                                    option =>
                                        option?.sysField === OpenAiUtil.defaultReasoningEffort(gptModelOfCorp, true)
                                );
                                if (detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT)
                                    setTagValue([defaultReasoningOption]);
                                break;
                            }
                            case Constant.SYSTEM_FIELD.EXECUTION_TIMEZONE: {
                                // TZL-001 (D4): default source for field「実行タイムゾーン」
                                // Order matters (a draft is also a detailTicket → must not check draft before the duplicate branch):
                                // 1. Has a valid value (edit prompt with existing value / duplicate keeps the original value) → let the common defaultValue block handle it.
                                // 2. Create new / duplicate (original empty, including duplicate from draft) → browser timezone if matched, otherwise Asia/Tokyo.
                                // 3. Edit normal prompt with empty value → Asia/Tokyo.
                                // 4. Edit draft with empty value → do not auto-fill.
                                const parsedTimezoneDefault = Utils.convertJSONDataToObject(props?.defaultValue);
                                const hasValidTimezoneDefault = !Utils.isEmptyArray(parsedTimezoneDefault) &&
                                    parsedTimezoneDefault.some(dv => {
                                        const dvValue = typeof dv === 'string' ? dv : dv?.value;
                                        return listOptionItemTagField.some(opt => opt.value === dvValue && opt.value !== null);
                                    });
                                if (hasValidTimezoneDefault) {
                                    break;
                                }

                                // Asia/Tokyo is the unified fallback for prompts (D3)
                                let targetTimezoneLabel = TimezoneConstant.getTimezoneByIana(Constant.DEFAULT_TIMEZONE)?.label;

                                if (isAddNewTicket || isDuplicate) {
                                    // §4.9.1: current timezone of the user (§4.1: userSetting.timeZone > browser > Asia/Tokyo)
                                    const userTimezoneText = TimezoneUtils.resolveUserTimezone(userDetail?.userSetting);
                                    const userTimezone = TimezoneConstant.getTimezoneForUserIana(userTimezoneText);
                                    if (userTimezone) {
                                        targetTimezoneLabel = userTimezone.label;
                                    }
                                } else if (detailTicket?.public === Constant.TICKET_PUBLIC.DRAFT) {
                                    // Edit draft with empty value → do not auto-fill
                                    break;
                                }
                                // else: edit normal (non-draft) prompt with empty value → keep Asia/Tokyo

                                const defaultTimezoneOption = listOptionItemTagField.find(
                                    opt => opt?.title === targetTimezoneLabel
                                );
                                if (defaultTimezoneOption) {
                                    setTagValue([defaultTimezoneOption]);
                                    props.setValue(props?.name, [defaultTimezoneOption]);
                                    return;
                                }
                                break;
                            }
                            default:
                        }            

                        // ticket detail, display value !? don't sure
                        if (props?.setTagListValue) {
                            props.setTagListValue([resFormatTagList[0]]);
                        }
                    }

                    if (
                        props.data.structure.optionType ===
                        Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE
                    ) {
                        //register auto select default value. can be more sysField in here, change if to switch.
                        if ([Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_RE_CAPTCHA,
                            Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING
                        ].includes(thisFieldInfo.sysField)) {
                            setTagValue([tagListSorted[0]]);
                        }

                        if (
                            thisFieldInfo.sysField === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING &&
                            (!props.defaultValue && Utils.isEmptyArray(tagValue))
                        ) {
                            setSdautoSelectedData(prev => ({
                                ...prev,
                                [Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING]: [tagListSorted[0]]
                            }))
                        }
                    }
                    if (props.defaultValue) {
                        const defaultValue = Utils.convertJSONDataToObject(props.defaultValue);

                        if (!Utils.isEmptyArray(defaultValue) && defaultValue.length > 0) {
                            let listDefaultValue = [];
                            defaultValue.forEach(tagSelected => {
                                if (typeof tagSelected === 'string') {
                                    listDefaultValue.push(tagSelected);
                                } else if (
                                    typeof tagSelected === 'object' &&
                                    !Utils.isEmptyObject(tagSelected)
                                ) {
                                    listDefaultValue.push(tagSelected.value);
                                }
                            });

                            let listDefaultSelectTag = resFormatTagList.filter(tag => {
                                if (listDefaultValue.includes(tag.value)) {
                                    return true;
                                } else {
                                    return false;
                                }
                            });

                            // override init tagValue = OFF when user is not PM handle duplicate
                            if (
                                props?.isDuplicate &&
                                !props?.isProjectManager
                            ) {
                                if (thisFieldInfo?.sysField === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING) {
                                    listDefaultSelectTag = resFormatTagList.filter(tag =>
                                        tag.sysField === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING_OFF
                                    );
                                    setSdautoSelectedData(prev => ({
                                        ...prev,
                                        [Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING]: [listDefaultSelectTag[0]]
                                    }))
                                }
                                if (thisFieldInfo?.sysField === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING_TARGET) {
                                    listDefaultSelectTag = []
                                }
                            }

                            /**
                             * logic for field ticket type of ai auto event form. start
                             */
                            if (
                                thisFieldInfo?.sysField ===
                                Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE
                            ) {
                                let selectedAiAutoTicketTypeValue = _.first(defaultValue);
                                if (_.isString(_.first(defaultValue))) {
                                    selectedAiAutoTicketTypeValue = _.first(defaultValue);
                                } else {
                                    selectedAiAutoTicketTypeValue = _.first(
                                        _.map(defaultValue, ii => ii?.value)
                                    );
                                }
                                if (!_.some(resFormatTagList, i => i?.value === selectedAiAutoTicketTypeValue)) {
                                    const ticketTypeOptionDontShow = _.find(
                                        fullAiAutoTicketTypeOptions,
                                        i => i?.value === selectedAiAutoTicketTypeValue
                                    );

                                    resFormatTagList = resFormatTagList.push({
                                        ...ticketTypeOptionDontShow,
                                        isShow: false
                                    });
                                    setTagValue([{...ticketTypeOptionDontShow, isShow:false}]);
                                    return props.setValue(props?.name, []);
                                }
                            }

                            /**
                             * logic for field ticket type of ai auto event form. start
                             */

                            // listDefaultSelectTag = new Set([...listDefaultSelectTag])
                            listDefaultSelectTag = [...new Map(listDefaultSelectTag.map(item => [item.value, item])).values()];
                   
                            setTagValue([...listDefaultSelectTag]);
                            props.setValue(props?.name, [...listDefaultSelectTag]);
                            if (props.setTagListValue) {
                               props.setTagListValue([...listDefaultSelectTag]);
                            }

                            if (
                                thisFieldInfo.sysField === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING
                            ) {
                                setSdautoSelectedData(prev => ({
                                    ...prev,
                                    [Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING]: [...listDefaultSelectTag]
                                }))
                            }

                            // return value in here to trans data to next then() in below.
                            return listDefaultSelectTag
                        } else {
                            if (!Utils.isEmptyArray(tagValue)) {
                                //default item of selected value
                                if (
                                    props.data.structure.optionType ===
                                        Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE &&
                                    !tagValue[0]?.value && props?.data?.sysField === Constant.SYS_FIELD.FIELD_QA_CATEGORY
                                ) {
                                    setTagValue(tagValue);
                                } else {
                                    setTagValue([]);
                                }
                            }

                            if (
                                thisFieldInfo.sysField === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING
                            ) {
                                if (!Utils.isEmptyArray(tagValue)) {
                                    setSdautoSelectedData(prev => ({
                                        ...prev,
                                        [Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING]: [tagValue[0]]
                                    }))
                                } else {
                                    setSdautoSelectedData(prev => ({
                                        ...prev,
                                        [Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING]: [tagListSorted[0]]
                                    }))
                                }
                            }
                        }

                    } else if (!Utils.isEmptyArray(tagValue)) {
                        if (thisFieldInfo?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL) {
                            let gptModelOfCorp = getValueTagChatGPTModelDefault([...tagListSorted]);
                            setTagValue([gptModelOfCorp]);
                        } else if (thisFieldInfo?.sysField !== Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT) {
                            setTagValue([]);
                        }

                        if (
                            thisFieldInfo.sysField === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING
                        ) {
                            setSdautoSelectedData(prev => ({
                                ...prev,
                                [Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING]: [...tagValue]
                            }))
                        }
                    }
                }).then((resTagList)=>{
                    /**
                     * call get form list options when view ai auto ticket detail by ticket type selected
                     */
                    if (_.includes(SYSTEM_FIELDS_NEED_LISTEN_EFFECT, thisFieldInfo?.sysField)) {
                        switch (thisFieldInfo?.sysField) {
                            case Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE:
                                let currentSelectedTicketType = _.find(resTagList, tagItem => {
                                    const thisFieldDefaultValue = Utils.convertJSONDataToObject(
                                        thisFieldInfo?.defaultValue
                                    );

                                    if (_.isString(_.first(thisFieldDefaultValue))) {
                                        return tagItem?.value === _.first(thisFieldDefaultValue);
                                    } else {
                                        return (
                                            tagItem?.value ===
                                            _.first(_.map(thisFieldDefaultValue, ii => ii?.value))
                                        );
                                    }
                                });
                                currentSelectedTicketType = currentSelectedTicketType
                                    ? currentSelectedTicketType
                                    : _.first(resTagList);
                                if (
                                    !Utils.isEmptyObject(currentSelectedTicketType) &&
                                    setAIAutoSelectedData
                                ) {
                                    setAIAutoSelectedData(prev => {
                                        return {
                                            ...prev,
                                            [Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE]: [
                                                currentSelectedTicketType
                                            ]
                                        };
                                    });
                                }
                                const {
                                    aiAutoCorporationQueryId,
                                    aiAutoProjectQueryId,
                                    aiAutoUserQueryId
                                } = getQueryParamsAIAuto();
                                getTagItemsByRelatedSystemFieldValue(
                                    aiAutoCorporationQueryId,
                                    aiAutoProjectQueryId,
                                    aiAutoUserQueryId,
                                    Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,
                                    currentSelectedTicketType,
                                    props?.setOptionsOfTagField,
                                    setIsLoadingInput,
                                    firstRender &&
                                    detailTicket &&
                                    detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT,
                                    formsInCorporation,
                                    fieldsInCorporation,
                                    projectsInCorporation,
                                    corporationDetail
                                );
                                break;
                            case Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER:
                                {
                                    const thisFieldDefaultValue = Utils.convertJSONDataToObject(
                                        thisFieldInfo?.defaultValue
                                    );

                                    if (
                                        !Utils.isEmptyArray(thisFieldDefaultValue) &&
                                        !Utils.isEmptyArray(resTagList) &&
                                        setAIAutoSelectedData
                                    ) {
                                        let selectedEventTrigger = thisFieldDefaultValue
                                            .map(tagItemId =>
                                                resTagList.find(item => item.value === tagItemId)
                                            )
                                            .filter(Boolean);
                                        setAIAutoSelectedData(prev => {
                                            return {
                                                ...prev,
                                                [Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER]: [
                                                    ...selectedEventTrigger
                                                ]
                                            };
                                        });
                                    }
                                }
                                break;
                            case Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL:
                                {
                                    const thisFieldDefaultValue = Utils.convertJSONDataToObject(
                                        thisFieldInfo?.defaultValue
                                    );

                                    if (
                                        !Utils.isEmptyArray(thisFieldDefaultValue) &&
                                        !Utils.isEmptyArray(resTagList) &&
                                        setAIAutoSelectedData
                                    ) {
                                        let selectedGptModel = thisFieldDefaultValue
                                            .map(tagItemId =>
                                                resTagList.find(item => item.value === tagItemId)
                                            )
                                            .filter(Boolean);
                                        if (!Utils.isEmptyArray(selectedGptModel)) {
                                            setAIAutoSelectedData(prev => ({
                                                ...prev,
                                                [Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL]: [...selectedGptModel]
                                            }));
                                            if (setAITelephoneSelectedData) {
                                                setAITelephoneSelectedData(prev => ({
                                                    ...prev,
                                                    [Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL]: [...selectedGptModel]
                                                }));
                                            }
                                        }
                                    }
                                }
                                break;
                            default:
                        }
                    }

                    // AI Telephone: Populate default values to aiTelephoneSelectedData
                    const AI_TELEPHONE_PARENT_FIELDS_INIT = [
                        Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION,
                        Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE,
                        Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD,
                        Constant.SYSTEM_FIELD.CHATGPT_MODEL,
                        Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE
                    ];

                    const isAITelephoneFormInit =Utils.isSystemFormAITelephonePrompt(props?.parentForm);
                    const isSystemFormAIAssistantPrompt =Utils.isSystemFormAIAssistantPrompt(props?.parentForm);

                    if (
                        (isAITelephoneFormInit || isSystemFormAIAssistantPrompt) &&
                        AI_TELEPHONE_PARENT_FIELDS_INIT.includes(thisFieldInfo?.sysField) &&
                        setAITelephoneSelectedData
                    ) {
                        const thisFieldDefaultValueTelephone = Utils.convertJSONDataToObject(thisFieldInfo?.defaultValue);

                        if (!Utils.isEmptyArray(thisFieldDefaultValueTelephone) && !Utils.isEmptyArray(resTagList)) {
                            let selectedItemsTelephone = thisFieldDefaultValueTelephone
                                .map(tagItemId => {
                                    if (typeof tagItemId === 'string') {
                                        return resTagList.find(item => item.value === tagItemId);
                                    } else if (typeof tagItemId === 'object') {
                                        return resTagList.find(item => item.value === tagItemId?.value);
                                    }
                                    return null;
                                })
                                .filter(Boolean);

                            if (!Utils.isEmptyArray(selectedItemsTelephone)) {
                                setAITelephoneSelectedData(prev => ({
                                    ...prev,
                                    [thisFieldInfo?.sysField]: selectedItemsTelephone
                                }));
                            }
                        } else if (
                            isAITelephoneFormInit &&
                            thisFieldInfo?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD &&
                            Utils.isEmptyArray(thisFieldDefaultValueTelephone)
                        ) {
                            // 専用時間帯設定 cleared (e.g. OFF via SIF write while the panel is open)
                            // → overwrite the stale selection so the time field group hides
                            setAITelephoneSelectedData(prev => ({
                                ...prev,
                                [thisFieldInfo?.sysField]: []
                            }));
                        }
                    }
                });
                })();
                break;
        }
    }, [props.data, props?.triggerReloadTicket]);

    useEffect(() => {
        setValidateError(props.data.error);
    }, [props.data]);

    const getListTicketOfItemList = (itemList, itemIdList) => {
        let ticketIdList = [];
        itemIdList.forEach(id => {
            const itemDetail = itemList.find(item => item.itemId === id);
            if (!Utils.isEmptyObject(itemDetail)) {
                const listTicketIdOfItem = itemDetail.listTicketId;
                listTicketIdOfItem.forEach(ticketId => {
                    if (!ticketIdList.includes(ticketId)) {
                        ticketIdList.push(ticketId);
                    }
                });
            }
        });
        return ticketIdList;
    };

    const getValueTagChatGPTModelDefault = (listOptionItemTagField, isGetModelName = false) => {
        const corpSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
        const corpLimitValue = Utils.convertJSONDataToObject(corporationDetail?.limitValue);
        const inviterSetting = Utils.convertJSONDataToObject(corporationDetail?.inviterSetting);

        const isGuestContract = [
            Constant.CORPORATION_CONTRACT_TYPE.GUEST,
            Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
        ].includes(corporationDetail?.contractType);

        const getFirstValidChatGptModel = () => {
            if (isGuestContract && inviterSetting?.chatGPTModel) {
                return inviterSetting?.chatGPTModel;
            }
            if (!Utils.isEmptyString(corpSetting?.chatGPTModel)) {
                return corpSetting?.chatGPTModel;
            }
            if (!Utils.isEmptyString(corpLimitValue?.chatGPTModel)) {
                return corpLimitValue?.chatGPTModel;
            }
            return '';
        };

        const gptModelKeyInCorp = getFirstValidChatGptModel();

        if (Utils.isEmptyString(gptModelKeyInCorp)) return '';

        if (isGetModelName) return gptModelKeyInCorp

        return listOptionItemTagField.find(item =>
            item.title?.toLowerCase() === gptModelKeyInCorp.toLowerCase()
        ) || '';
    };

    const getSelectedChatGptModelName = () => {
        const chatGptModelValue =
            aiAutoSelectedData?.[Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL];
        if (Utils.isEmptyArray(chatGptModelValue)) return '';

        const selectedModel = chatGptModelValue[0] || {};
        const modelFromTag = OpenAiUtil.getModelIdFromTagSysField(selectedModel?.sysField);
        return (
            modelFromTag ||
            selectedModel?.title ||
            selectedModel?.value ||
            selectedModel?.name ||
            ''
        );
    };

    useEffect(() => {
        //remove default empty item with its value = null
        const validTagValues = tagValue.filter(i => i?.value !== null && i !== null);
        props.setValue(props?.name, [...validTagValues]);
        // if (props?.setIsExChangeTagField) {
        //     props?.setIsExChangeTagField(!props?.isExChangeTagField);
        // }
        /**
         * validate and handle error for fields in ai auto event form. start
         */
        if (
            [
                Constant.AI_AUTO.SYSTEM_FIELD.AND,
                Constant.AI_AUTO.SYSTEM_FIELD.OR,
                Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE
            ].includes(props?.data?.sysField)
        ) {
            /**this logic used to logic in "this comment for note 18/12/2024", find by comment
             * fake a item to pass logic validate with tag value. because that logic created validate required field. but in here we need to be enable submit button when don't have any items error into input.
             * */

            const corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
            const hasUnsupportedModel = _.some(validTagValues, tagItem => {
                return isModelUnsupportedForTagItem(tagItem, corporationSetting);
            });

            if (hasUnsupportedModel) {
                props.setValue(props?.name, []);
                const tagValueToEnableEditButton = [Constant.FIELD_UI_SELECT_DEFAULT_ITEM];
                props?.setShowButtonEditTicket &&
                    props?.setShowButtonEditTicket(tagValueToEnableEditButton);
                
                return setValidateError({
                    isError: true,
                    message: trI18n('MSG-CM-TAG-ITEM-UNAVAILABLE')
                });
            }

            const tagValueToEnableEditButton = Utils.isEmptyArray(validTagValues)
                ? [Constant.FIELD_UI_SELECT_DEFAULT_ITEM]
                : validTagValues;
            props?.setShowButtonEditTicket &&
                props?.setShowButtonEditTicket(tagValueToEnableEditButton);
        }
        if (
            _.some(validTagValues, i => !i?.isShow) &&
            ![
                Constant.AI_AUTO.SYSTEM_FIELD.AND,
                Constant.AI_AUTO.SYSTEM_FIELD.OR,
                Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE
            ].includes(props?.data?.sysField)
        ) {
            return setValidateError({
                isError: true,
                message: trI18n('MSG-CM-TAG-ITEM-UNAVAILABLE')
            });
        }
        /**
         * validate and handle error for fields in ai auto event form. end
         */
        if (!Utils.isEmptyArray(validTagValues)) {
            setValidateError({
                isError: false,
                message: ''
            });
            props.clearErrors(props.name);
        }
        if(firstRender) {
            setValidateError({
                isError: false,
                message: ''
            });
            props.clearErrors(props.name);
        }

        if(
            (!firstRender && props?.isEdited) &&
            props.data.structure.required &&
            Utils.isEmptyArray(validTagValues)
            ) {
            setValidateError({
                isError: true,
                message: tr('このフィールドは入力必須です。')
            });

            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(validTagValues);
            
        } else {
            if(props.data.structure.required)//if it is field required, we will update to change state submit enable or not
                props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(validTagValues);
            setValidateError(props.data?.error);
        }

        if (props?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL) {
            let corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
            if (!Utils.isEmptyArray(tagValue)) {
                let isValid = checkModelUnsupport(tagValue[0]?.title, corporationSetting.listChatGptModel);
                if (isValid) {
                    setValidateError({
                        isError: true,
                        message: trI18n('MSG-AI-UNSUPPORTED-MODEL').replace(Constant.MODEL_NAME_PLACEHOLDER, tagValue[0]?.title)
                    });
                }
            }
        }

        if (props?.data?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_REALTIME_MODEL) {
            if (!Utils.isEmptyArray(tagValue)) {
                if (TelephoneConstant.UNSUPPORTED_REALTIME_MODELS.includes(tagValue[0]?.title)) {
                    setValidateError({
                        isError: true,
                        message: trI18n('MSG-AI-UNSUPPORTED-MODEL').replace(Constant.MODEL_NAME_PLACEHOLDER, tagValue[0]?.title)
                    });
                }
            }
        }
    }, [tagValue, firstRender]);

    const checkModelUnsupport = (modelId, chatGPTModelList = []) => {
        let modelList = Utils.isEmptyArray(chatGPTModelList) ? [] : chatGPTModelList;
        const model = modelList.find(item => item?.id === modelId?.toLowerCase());
        return model?.status === Constant.CHAT_GPT_MODEL_STATUS.UNSUPPORT;
    };

    useEffect(() => {
        const validTagValues = tagValue.filter(i => i?.value !== null && i !== null);
        if(!Utils.isEmptyString(props.submitTime)){
            if(
                props.data.structure.required &&
                Utils.isEmptyArray(validTagValues)
                ) {
                setValidateError({
                    isError: true,
                    message: tr('このフィールドは入力必須です。')
                });
    
                props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(validTagValues);
                
            }
        }
    },[props?.submitTime])

    useEffect(async () => {
        const thisFieldInfo = props?.data;
        const SYSTEM_FIELDS_NEED_LISTEN_EFFECT = [
            Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
            Constant.AI_AUTO.SYSTEM_FIELD.AND,
            Constant.AI_AUTO.SYSTEM_FIELD.OR,
            Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE,
            Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER,
            Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER
        ];

        if (Utils.isEmptyObject(props?.optionsOfTagField)) return true;
        if (!_.includes(SYSTEM_FIELDS_NEED_LISTEN_EFFECT, thisFieldInfo?.sysField)) return true;

        let optionsOfThisField = props?.optionsOfTagField[thisFieldInfo?.sysField];
        if (thisFieldInfo?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE) {
            if (!Utils.isCorporationOnSDAuto(corporationDetail)) {
                optionsOfThisField = optionsOfThisField.filter(form => !Utils.isSystemSDAutoForm(form));
            }

            if (!Utils.isCorporationOnKBoardPrompt(corporationDetail)) {
                optionsOfThisField = optionsOfThisField.filter(form =>
                    !Utils.isSystemFormKBoardPrompt(form) && !Utils.isSystemKBoardKnowledgeForm(form)
                );
            }

            if (
                !Utils.isEnableSettingTelephoneAgent(corporationDetail)
            ) {
                optionsOfThisField = optionsOfThisField.filter(
                    form => !Utils.isSystemFormAITelephonePrompt(form)
                );
               
            }

            if (
                !Utils.isCorporationOnKnowledge(corporationDetail) ||
                !Utils.isEnableSettingTelephoneAgent(corporationDetail) ||
                !Utils.isProjectDeskOn(projectDetail) ||
                !Utils.isCorporationOnAI(corporationDetail)
            ) {
                optionsOfThisField = optionsOfThisField.filter(
                    form => !Utils.isSystemFormAIAssistantPrompt(form)
                );
            }
        }
        await changeTagListByFieldOfThisField(thisFieldInfo?.sysField, optionsOfThisField);
    }, [props?.optionsOfTagField]);

    const changeTagListByFieldOfThisField = async (sysField, optionsOfThisField = []) => {
        /**fake data options using for tag items of ai auto fields */
        const fakeDataOptions = (pureOptionsOfThisField, isDeathOption = false) => {
            return pureOptionsOfThisField.map((pureOptionDetail, idx) => {
                let isShow = pureOptionDetail?.isShow

                if(isDeathOption) isShow = false

                if (props?.fieldListDefaultData) {
                    const aiAutoFormEventField = _.find(
                        props?.fieldListDefaultData,
                        item => item?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE
                    );
                    const valuesForm = props?.getValues()
                    const [formEventFieldValue] = valuesForm[aiAutoFormEventField?.id]
                    if (
                        !formEventFieldValue?.isShow &&
                        _.includes(
                            [
                                Constant.AI_AUTO.SYSTEM_FIELD.AND,
                                Constant.AI_AUTO.SYSTEM_FIELD.OR,
                                Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE
                            ],
                            props?.data?.sysField
                        )
                    ) {
                        isShow = false;
                    }
                }

                // Filter out unsupported ChatGPT model tags for AND/OR/EXCLUDE fields
                if (
                    sysField === Constant.AI_AUTO.SYSTEM_FIELD.AND ||
                    sysField === Constant.AI_AUTO.SYSTEM_FIELD.OR ||
                    sysField === Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE
                ) {
                    const corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
                    if (isModelUnsupportedForTagItem(pureOptionDetail, corporationSetting)) {
                        isShow = false;
                    }
                    
                    // Filter out 外部 (EXTERNAL) option of AI-プロンプト適用先 when selected form is K-Board Prompt
                    if (
                        pureOptionDetail?.sysField === Constant.AI_SYSTEM_FIELD_TARGET_OPTION_TAGS.EXTERNAL &&
                        props?.fieldListDefaultData
                    ) {
                        const formActiveField = _.find(
                            props?.fieldListDefaultData,
                            item => item?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE
                        );
                        if (formActiveField) {
                            const currentValues = props?.getValues();
                            const [selectedFormValue] = currentValues[formActiveField?.id] || [];
                            const selectedFormDetail = _.find(
                                formsInCorporation,
                                form => form?.id === selectedFormValue?.value
                            );
                            if (Utils.isSystemFormKBoardPrompt(selectedFormDetail)) {
                                isShow = false;
                            }
                        }
                    }
                }

                return {
                    id: pureOptionDetail?.id,
                    name: pureOptionDetail?.name,
                    structure: {
                        no: idx,
                        isShowItemInTicket: true
                    },
                    hitNumber: idx,
                    sysField: pureOptionDetail?.sysField || sysField,
                    originalSysField: pureOptionDetail?.sysField,
                    isShow
                };
            });
        };
        
        let formattedTagItems = []
        switch (sysField) {
            case Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE:
                const formatFormOptionsForFormatTagList = fakeDataOptions(optionsOfThisField)
                formattedTagItems = formatTagList(formatFormOptionsForFormatTagList);
                formattedTagItems = [Constant.FIELD_UI_SELECT_DEFAULT_ITEM, ...formattedTagItems]

                /**validate form unshare of prj inuse */
                const defaultValuesClone = Utils.convertJSONDataToObject(props?.defaultValue);
                let defaultOptionsClone = _.filter(formattedTagItems, i => {
                    if (_.isString(_.first(defaultValuesClone))) {
                        return _.includes(defaultValuesClone, i?.value);
                    }
                    return _.includes(
                        _.map(defaultValuesClone, ii => ii?.value),
                        i?.value
                    );
                });

                if(props?.defaultValue && !Utils.isEmptyArray(defaultValuesClone) && Utils.isEmptyArray(defaultOptionsClone) && firstRender) {
                    // if list form only default item. we don't need do anything.
                    if (formattedTagItems.length <= 1) {
                        setTagList([Constant.FIELD_UI_SELECT_DEFAULT_ITEM]);
                        setTagValue([Constant.FIELD_UI_SELECT_DEFAULT_ITEM]);
                        props.setValue(props?.name, []);
                    } else {
                        const deathForm = await getFormById(null, _.first(defaultValuesClone));
                        const formattedTagItemsHaveDeathForm = _.concat(
                            formattedTagItems,
                            formatTagList(fakeDataOptions([deathForm], true))
                        );
                        // set values display it in FE and set value its to form
                        const defaultOptionsDeath = _.filter(formattedTagItemsHaveDeathForm, i => {
                            if (_.isString(_.first(defaultValuesClone))) {
                                return _.includes(defaultValuesClone, i?.value);
                            }
                            return _.includes(
                                _.map(defaultValuesClone, ii => ii?.value),
                                i?.value
                            );
                        });
                        setTagValue(defaultOptionsDeath);
                        setTagList(formattedTagItems);
                        props.setValue(props?.name, []);

                        setValidateError({
                            isError: true,
                            message: trI18n('MSG-CM-TAG-ITEM-UNAVAILABLE')
                        });
                    }
                    // const setLoading = props?.setIsLoadingNotRefreshData
                    //     ? props?.setIsLoadingNotRefreshData
                    //     : props?.setIsLoading
                    return setIsLoadingInput(false)
                }
                /**validate form unshare of prj inuse.end */
                //set new tag list and reset selected tag
                const isFormListChanged = _.isEqual(tagList, formattedTagItems)
                if (!isFormListChanged) {
                    /**
                     * reset value when change selected form. start
                     */
                    //set form options list
                    setTagList(formattedTagItems);
                    //reset show error
                    setFirstRender(true);
                    if (props?.defaultValue) {
                        /**fill data for view ticket detail */
                        const defaultValues = Utils.convertJSONDataToObject(props?.defaultValue);
                        /**why coding like this !.
                         * Because data format of props?.defaultValue when we view ticket detail is id.
                         * but when change tab. it is object.
                         * Similar for data of and, or and exclude field.
                        */
                        const defaultOptions = _.filter(formattedTagItems, i => {
                            if (_.isString(_.first(defaultValues))) {
                                return _.includes(defaultValues, i?.value);
                            }
                            return _.includes(
                                _.map(defaultValues, ii => ii?.value),
                                i?.value
                            );
                        });
                        // set values display it in FE and set value its to form
                        setTagValue(defaultOptions);
                        props?.setValue(props?.name, defaultOptions);

                        const {
                            aiAutoCorporationQueryId,
                            aiAutoProjectQueryId,
                            aiAutoUserQueryId
                        } = getQueryParamsAIAuto();
                        return getTagItemsByRelatedSystemFieldValue(
                            aiAutoCorporationQueryId,
                            aiAutoProjectQueryId,
                            aiAutoUserQueryId,
                            Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE,
                            _.first(defaultOptions),
                            props?.setOptionsOfTagField,
                            setIsLoadingInput,
                            (firstRender && props?.detailTicket && props?.detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT),
                            formsInCorporation,
                            fieldsInCorporation,
                            projectsInCorporation,
                            corporationDetail
                        );
                            } else {
                        setTagValue([Constant.FIELD_UI_SELECT_DEFAULT_ITEM]);
                    }
                    setValidateError({
                        isError: false,
                        message: tr('このフィールドは入力必須です。')
                    });

                    // Reset 
                    setAIAutoSelectedData(prev => {
                        let newSelectedDataList = [];
                        let currentPrev = {...prev};

                        if (currentPrev?.[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER]) {
                            let currentSelectedDataList = currentPrev[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER];
                            if (!Utils.isEmptyArray(currentSelectedDataList)) {
                                currentSelectedDataList.forEach(eventTriggerItem => {
                                    if (validateShowTagItemEventTrigger(eventTriggerItem, aiAutoSelectedData)) {
                                        newSelectedDataList.push(eventTriggerItem); 
                                    }
                                })
                            }
                        }

                        return {
                            ...prev,
                            [Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER]: [...newSelectedDataList]
                        };
                    });

                    /**
                     * reset value when change selected form. end
                     */
                }
                break;
            case Constant.AI_AUTO.SYSTEM_FIELD.AND:
            case Constant.AI_AUTO.SYSTEM_FIELD.OR:
            case Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE:
                const formatOptionsForAndOrExcludeFields = fakeDataOptions(optionsOfThisField)
                formattedTagItems = formatTagList(formatOptionsForAndOrExcludeFields);

                const isOptionsOfFormChanged = _.isEqual(tagList, formattedTagItems)
                /**
                 * reset value when change form. start
                 */
                if (!isOptionsOfFormChanged) {
                    //set values for and, or and exclude selected.
                    let newTagOptions = formattedTagItems
                    setTagList(newTagOptions);

                    if (props?.defaultValue && firstRender) {
                        const defaultValues = Utils.convertJSONDataToObject(props?.defaultValue);
                        const defaultOptions = _.filter(newTagOptions, i => {
                            if (_.isString(_.first(defaultValues))) {
                                return _.includes(defaultValues, i?.value);
                            }
                            return _.includes(
                                _.map(defaultValues, ii => ii?.value),
                                i?.value
                            );
                        });

                        if (!Utils.isEmptyArray(defaultValues) && Utils.isEmptyArray(defaultOptions)) {
                            setTagValue([]);
                            props?.setValue(props?.name, []);

                            setValidateError({
                                isError: true,
                                message: trI18n('MSG-CM-TAG-ITEM-UNAVAILABLE')
                            });
                        } else {
                            const corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
                            const hasUnsupportedModelInDefaults = _.some(defaultOptions, tagItem => {
                                return isModelUnsupportedForTagItem(tagItem, corporationSetting);
                            });

                            if (hasUnsupportedModelInDefaults) {
                                setTagValue(defaultOptions);
                                props?.setValue(props?.name, []);

                                setValidateError({
                                    isError: true,
                                    message: trI18n('MSG-CM-TAG-ITEM-UNAVAILABLE')
                                });
                            } else {
                                const onlyDisplayShowOption = _.filter(defaultOptions, i=> i?.isShow)
                                setTagValue(onlyDisplayShowOption);
                                props?.setValue(props?.name, defaultOptions);
                            }
                        }
                    } else {
                        setTagValue([]);
                    }
                }
                   /**
                 * reset value when change selected form. start
                 */
                break
            case Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER:
                setTagList(prev => {
                    let itemList = [...prev];
                    itemList = itemList.map(tagItem => {
                        let isShow = validateShowTagItemEventTrigger(tagItem, aiAutoSelectedData);
                        return {...tagItem, isShow}
                    })

                    return itemList;
                })
                break;
            case Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER:
                setTagList(prev => {
                    let itemList = [...prev];
                    itemList = itemList.map(tagItem => {
                        let isShow = validateShowTagItemEventTypeChatThread(tagItem, aiAutoSelectedData);
                        return {...tagItem, isShow}
                    })

                    return itemList;
                })
                break;
            default:
        }
    };

    const compareListItem = (firstArray, secondArray) => {
        if (firstArray.length !== secondArray.length) {
            return false;
        }
        firstArray.forEach(itemOfFirstArray => {
            const findResult = secondArray.find(itemOfSecondArray => {
                return itemOfFirstArray.value === itemOfSecondArray.value;
            });
            if (Utils.isEmptyObject(findResult)) {
                return false;
            }
        });
        return true;
    };

    const resetItemList = (selectedTicketIdOfMasterForm, orderOfSelectedFields) => {
        let newItemIdList = [];
        let newItemList = [];
        let listItem = props.data.structure.listItem;
        orderOfSelectedFields.forEach((fieldId, index) => {
            // filter theo các field đã được chọn trước đó
            const selectedTicketIdListOfField = selectedTicketIdOfMasterForm[`${fieldId}`];
            const listItemTmp = cloneDeep(listItem);
            if (!Utils.isEmptyArray(selectedTicketIdListOfField)) {
                listItem = listItemTmp.filter(item => {
                    return isExistSameItem(item.listTicketId, selectedTicketIdListOfField);
                });
            }
        });
        listItem.forEach(item => newItemIdList.push(item.itemId));
        newItemList = originItemList.filter(item => newItemIdList.includes(item.value));
        setTagList([...newItemList]);
        if (newItemList.length === 1) {
            setTagValue([...newItemList]);
        }
    };

    const filterFieldAutoFill = (
        selectedTicketIdOfMasterForm,
        orderOfSelectedFields,
        autoFillObjectClone,
        indexOfField
    ) => {
        let newItemIdList = [];
        let newItemList = [];
        let listItem = props.data.structure.listItem;
        const currentTagValue = cloneDeep(tagValue);
        orderOfSelectedFields.forEach((fieldId, index) => {
            // filter theo các field đã được chọn trước đó
            if (indexOfField === -1 || index < indexOfField) {
                const selectedTicketIdListOfField = selectedTicketIdOfMasterForm[`${fieldId}`];
                const listItemTmp = cloneDeep(listItem);
                if (!Utils.isEmptyArray(selectedTicketIdListOfField)) {
                    listItem = listItemTmp.filter(item => {
                        return isExistSameItem(item.listTicketId, selectedTicketIdListOfField);
                    });
                }
            }
        });
        listItem.forEach(item => newItemIdList.push(item.itemId));
        newItemList = originItemList.filter(item => newItemIdList.includes(item.value));
        setTagList([...newItemList]);
        let newTagValue = [];
        if (currentTagValue.length !== 0) {
            newTagValue = currentTagValue.filter(item => newItemIdList.includes(item.value));
        }
        if (newItemList.length === 1) {
            setTagValue([...newItemList]);
        } else {
            if (orderOfSelectedFields.includes(props.name)) {
                setTagValue([...newTagValue]);
            } else {
                setTagValue([]);
            }
        }
        //khi có item của của field đã được chọn bị xóa khỏi list item sau filter
        if (
            orderOfSelectedFields.includes(props.name) &&
            !compareListItem(newTagValue, currentTagValue)
        ) {
            let listItemOfField = props.data.structure.listItem;
            let selectedItemIdList = [];
            newTagValue.forEach(item => selectedItemIdList.push(item?.value));
            selectedTicketIdOfMasterForm[`${props.name}`] =
                newTagValue.length === 0
                    ? []
                    : getListTicketOfItemList(listItemOfField, selectedItemIdList);
            autoFillObjectClone.orderOfSelectedFields =
                newTagValue.length === 0
                    ? orderOfSelectedFields.filter(id => id !== props.name)
                    : orderOfSelectedFields;
            autoFillObjectClone.selectedTicketIdOfMasterForm = selectedTicketIdOfMasterForm;
            props.setAutoFillObject({ ...autoFillObjectClone });
        }

        return;
    };

    useEffect(() => {
        try {
            if (
                props.data.structure.isAutoFill &&
                props.data.structure.settingSelectItem ===
                    Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL
            ) {
                let autoFillObjectClone = cloneDeep(props.autoFillObject);
                let orderOfSelectedFields = Utils.isEmptyArray(
                    autoFillObjectClone.orderOfSelectedFields
                )
                    ? []
                    : autoFillObjectClone.orderOfSelectedFields;
                let currentFieldChangeInfo = Utils.isEmptyArray(
                    autoFillObjectClone.currentFieldChangeInfo
                )
                    ? []
                    : autoFillObjectClone.currentFieldChangeInfo;
                let selectedTicketIdOfMasterForm = Utils.isEmptyArray(
                    autoFillObjectClone.selectedTicketIdOfMasterForm
                )
                    ? {}
                    : autoFillObjectClone.selectedTicketIdOfMasterForm;
                const indexOfField = orderOfSelectedFields.findIndex(id => id == props.name);
                // Không filter item được click
                if (
                    !Utils.isEmptyObject(autoFillObjectClone) &&
                    props.name !== currentFieldChangeInfo?.fieldId
                ) {
                    if (!orderOfSelectedFields.includes(props.name)) {
                        // filter các field chưa được click
                        filterFieldAutoFill(
                            selectedTicketIdOfMasterForm,
                            orderOfSelectedFields,
                            autoFillObjectClone,
                            indexOfField
                        );
                    } else {
                        // filter các item được click sau item được click
                        if (
                            indexOfField >= currentFieldChangeInfo.index &&
                            currentFieldChangeInfo.typeOfChange === 'changeItem'
                        ) {
                            filterFieldAutoFill(
                                selectedTicketIdOfMasterForm,
                                orderOfSelectedFields,
                                autoFillObjectClone,
                                indexOfField
                            );
                        }
                    }
                }
            }
        } catch (error) {
            
        }
    }, [props.autoFillObject, originItemList]);


    const onChangeCheckBoxHandler = e => {
        setFirstRender(false)
        let newTagValue;
        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }
        }
        if (e.target.checked) {
            const checkedItem = tagList.find(item => item.value === e.target.value);
            newTagValue = cloneDeep([...tagValue, checkedItem]);
            setTagValue([...tagValue, checkedItem]);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(newTagValue);
            return newTagValue;
        } else {
            newTagValue = tagValue.filter(item => item.value !== e.target.value);
            setTagValue([...newTagValue]);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(tagValue);
            return newTagValue;
        }
    };

    const onChangeRadioButtonHandler = e => {
        setFirstRender(false)
        const index = tagList.findIndex(tag => tag.value === e.target.value);

        if (
            props.data.structure.isAutoFill &&
            props.data.structure.settingSelectItem ===
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL
        ) {
            if (tagValue[0]) {
                if (e.target.value === tagValue[0].value) {
                    setTagValue([]);
                    setDefaultIndexChecked(index);
                    return [];
                }
            }
        }
        const newTagValue = cloneDeep([tagList[index]]);

        if(!isDisableField)
            setTagValue([tagList[index]]);
        

        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            if(!props?.listFieldEdited?.includes(props?.name)){
                props?.setListFieldEdited([...props.listFieldEdited,props?.name])
            }

            //using for unchecked radio button
            if ((tagValue[0]?.value === e.target.value || !e.target.value) && !isDisableField)
                return setTagValue([{ value: null }]);
            
        }
        setDefaultIndexChecked(index);
        return newTagValue;
    };


    const handleOnKeyPressAddItem = e => {
        if (Utils.isEmptyString(e.target.value.trim())) {
            if (e.key === 'Enter') {
                setErrorsAddItem(tr('選択項目を入力してください。'));
            }
            return;
        }
        if (e.key === 'Enter') {
            const newItem = {
                title: e.target.value,
                value: `${new Date().getTime()}`,
                isNewItem: true,
                no: tagList.length + 1
            };
            let tagListTemp = tagList;
            if (
                enableShowMore ||
                props.data.structure.optionType === Constant.TAG_FIELD_OPTION_TYPE.SELECT
            ) {
                tagListTemp.push(newItem);

                if (props.data.structure.isMultiple) {
                    setTagValue([...tagValue, newItem]);
                } else {
                    setDefaultIndexChecked(tagListTemp.length);
                    setTagValue([newItem]);
                }
            } else {
                const tagListLength = tagList.length;
                let indexOfNewItem = numOfRecordDisplay;
                if (tagListLength <= numOfRecordDisplay) {
                    indexOfNewItem = tagListLength;
                }
                tagListTemp.splice(indexOfNewItem, 0, newItem);
                if (props.data.structure.isMultiple) {
                    setTagValue([...tagValue, newItem]);
                } else {
                    setDefaultIndexChecked(indexOfNewItem);
                    setTagValue([newItem]);
                }
                setNumOfRecordDisplay(Number(numOfRecordDisplay) + 1);
            }
            if (props?.setIsEdited) {
                if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
                props?.setIsEdited(true);
                if(!props?.listFieldEdited?.includes(props?.name)){
                    props?.setListFieldEdited([...props.listFieldEdited,props?.name])
                }
            }
            setTagList([...tagListTemp]);
            setShowAddItemInput(false);
        } else {
            return;
        }
    };

    const enableShowMoreTagList = () => {
        setEnableShowMore(true);
        setIsLoadingInput(true)
        if (
            props.data.structure.optionType === Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE
        ) {
            if (!props.data.structure.isMultiple) {
                const defaultSelectItem = getSelectDefaultItemBySysField(
                    props.data?.sysField
                );
                let listOptionItemTagField = [defaultSelectItem, ...tagList];
                setTagList([...listOptionItemTagField]);
                if (Utils.isEmptyArray(tagValue)) {
                    setTagValue([defaultSelectItem]);
                }
            }
        }
        return queryLoadMoreTagItems().finally(()=>{
            setIsLoadingInput(false)
        })
    };

    const queryLoadMoreTagItems = async () => {
        if (Utils.isEmptyObject(nextToken)) return;

        const result = await queryFieldChild(
            props?.API,
            props.data.affiliationOrganization,
            props.data.id,
            props.data,
            nextToken,
            null,
            true,
            projectDetail?.id
        );
        const newTagFieldItems = result?.fieldChildList || result;
        if (newTagFieldItems?.length > 0) {
            addMoreAndSortTagItems(newTagFieldItems);
        }
        if (!result?.nextToken) return setNextToken(null);
        setNextToken(result?.nextToken);
    };

    const addMoreAndSortTagItems = (newTagItems = [], fieldInfo = props?.data) => {
        let tagItemListByFilter = [];
        const systemTagChildList = SystemField.filter(
            item =>
                item.usage === Constant.FORM_USAGE.TAG && item.affiliationField === props.data.id
        );

        if (!Utils.isEmptyArray(newTagItems)) {
            newTagItems.forEach(item => {
                let structure = Utils.isEmpty(item.structure)
                    ? {}
                    : Utils.convertJSONDataToObject(item.structure);
                if (structure.isShowItemInTicket || Utils.isEmptyObject(structure)) {
                    tagItemListByFilter.push(item);
                }
            });
        }

        const tagChildList = !Utils.isEmptyArray(tagItemListByFilter)
            ? tagItemListByFilter.concat(systemTagChildList)
            : systemTagChildList;

        let resFormatTagList = [...tagList, ...formatTagList(tagChildList)];
        let displayOrder = props.data?.structure?.displayOrder;

        // ensure unique items.
        const seen = new Set();
        const uniqueData = resFormatTagList.filter(obj => {
            if (seen.has(obj.id)) return false;
            seen.add(obj.id);
            return true;
          });
        let tagListSorted = uniqueData

        /**
         * filter items by project type. and setting on funcs
         */

        switch (fieldInfo?.sysField) {
            case Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE:
                const TICKET_TYPES_FOR_DESK_OFF_PROJECT = [
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.TASK,
                    Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.KNOWLEDGE
                ];

                const { aiAutoProjectDetail, aiAutoCorporationDetail } = getQueryParamsAIAuto();
                if (Utils.isPublicOffDeskOff(aiAutoProjectDetail)) {
                    resFormatTagList = _.filter(resFormatTagList, form =>
                        _.includes(TICKET_TYPES_FOR_DESK_OFF_PROJECT, form?.sysField)
                    );
                }
                if (
                    !Utils.isEnableCreateEmailTicketMode(
                        aiAutoCorporationDetail,
                        aiAutoProjectDetail
                    )
                ) {
                    resFormatTagList = _.filter(resFormatTagList, form => {
                        return form?.sysField !== Constant.AI_AUTO.TICKET_TYPE_TAG_OPTIONS.EMAIL;
                    });
                }
                break;
            default:
        }

        switch (displayOrder) {
            case Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER:
                tagListSorted = resFormatTagList.sort(sortItemWithHitNumber);
                break;
            case Constant.DISPLAY_ORDER_TAG_FIELD.DICTIONARY_ORDER:
                tagListSorted = resFormatTagList.sort((a, b) => {
                    let nameA = a.title;
                    let nameB = b.title;
                    return nameA.localeCompare(nameB);
                });
                break;
            case Constant.DISPLAY_ORDER_TAG_FIELD.CUSTOMISE:
            default:
                tagListSorted = resFormatTagList.sort((item1, item2) => {
                    return item1.no - item2.no;
                });
                break;
        }

        // Filter reasoning_effort options based on selected chatgpt_model
        if (fieldInfo?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT) {
            tagListSorted = tagListSorted.map(tagItem => {
                return {
                    ...tagItem,
                    isShow: validateShowTagItemReasoningEffort(tagItem, aiAutoSelectedData)
                };
            });
        }

        setTagList(_.unionBy([...tagListSorted], 'value'));

        if ([...tagListSorted].length > 0 && props?.setIsTagList) {
            props?.setIsTagList(true);
        }

        // single choice and multiple choice select fields will select a default empty item. <Constant.FIELD_UI_SELECT_DEFAULT_ITEM>
        if (
            props.data.structure.optionType ===
                Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE
        ) {
            const defaultSelectItem = getSelectDefaultItemBySysField(
                props.data?.sysField
            );
            let listOptionItemTagField = [...tagListSorted]

            if (
                !props.data.structure.isMultiple &&
                ![
                    Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL,
                    Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT,
                    Constant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER
                ].includes(props.data?.sysField)
            ) {
                listOptionItemTagField = [defaultSelectItem, ...tagListSorted];
            }
            setTagList(_.unionBy([...listOptionItemTagField], 'value'));
        }
    };

    const isCheckedItem = itemValue => {
        const foundItem = tagValue.find(element => element.value === itemValue);
        if (!Utils.isEmptyObject(foundItem)) {
            return true;
        } else {
            return false;
        }
    };

    const onChangeAddItem = e => {
        setFirstRender(false)
        if (Utils.isEmptyString(e.target.value)) {
            setErrorsAddItem(tr('選択項目を入力してください。'));
        } else {
            setErrorsAddItem('');
        }
    };

    const isExistSameItem = (firstItemList, secondItemList) => {
        if (!Utils.isEmptyArray(firstItemList) && !Utils.isEmptyArray(secondItemList)) {
            const sameItemList = firstItemList.filter(item => {
                return secondItemList.includes(item);
            });
            return !Utils.isEmptyArray(sameItemList);
        }
        return false;
    };

    const checkContainsArray = (firstElementsList, secondElementsList) => {
        const lengthOfFistList = firstElementsList.length;
        for (let i = 0; i < lengthOfFistList; i++) {
            let indexOfElement = secondElementsList.findIndex(
                item => item.value === firstElementsList[i].value
            );
            if (indexOfElement === -1) {
                return false;
            }
        }
        return true;
    };

    const onClickHandler = eventObj => {
        const SYSTEM_FIELDS_HAVE_DEPENDENT_QUERY = [
            Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE,
            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER,
            Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING
        ];
        setFirstRender(false)
        let currentTagValue = cloneDeep(tagValue);
        let newTagValue = [];
        switch (eventObj.type) {
            case 'checkBox': {
                newTagValue = onChangeCheckBoxHandler(eventObj.value);
                
                // AI Telephone parent fields that need to be tracked (checkbox)
                const AI_TELEPHONE_CHECKBOX_PARENT_FIELDS = [
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE
                ];

                const sysFieldOfCheckbox = props?.data?.sysField;
                const isAITelephoneFormCheckbox =Utils.isSystemFormAITelephonePrompt(props?.parentForm);
                
                // Update aiTelephoneSelectedData for AI Telephone checkbox fields
                if (
                    isAITelephoneFormCheckbox &&
                    AI_TELEPHONE_CHECKBOX_PARENT_FIELDS.includes(sysFieldOfCheckbox) && 
                    setAITelephoneSelectedData
                ) {
                    setAITelephoneSelectedData(prev => {
                        const currentData = { ...(prev || {}) };
                        
                        return {
                            ...currentData,
                            [sysFieldOfCheckbox]: newTagValue || []
                        };
                    });
                }
                break;
            }
            case 'radio': {
                newTagValue = onChangeRadioButtonHandler(eventObj.value);

                if (!newTagValue || Utils.isEmptyArray(newTagValue)) break;

                const sysFieldOfThisField = props?.data?.sysField;
                if (sysFieldOfThisField === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING) {
                    setSdautoSelectedData(prev => {
                        let clonedData = {...prev}
                        return ({
                            ...clonedData,
                            [Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING]: [...newTagValue]
                        })
                    });
                }

                // AI Telephone parent fields that need to be tracked (radio)
                const AI_TELEPHONE_RADIO_PARENT_FIELDS = [
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD,
                    Constant.SYSTEM_FIELD.CHATGPT_MODEL,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE
                ];

                const isAITelephoneFormRadio =Utils.isSystemFormAITelephonePrompt(props?.parentForm);
                
                // Update aiTelephoneSelectedData for AI Telephone radio fields
                if (
                    isAITelephoneFormRadio &&
                    AI_TELEPHONE_RADIO_PARENT_FIELDS.includes(sysFieldOfThisField) && 
                    setAITelephoneSelectedData
                ) {
                    setAITelephoneSelectedData(prev => {
                        const currentData = { ...(prev || {}) };
                        
                        return {
                            ...currentData,
                            [sysFieldOfThisField]: newTagValue
                        };
                    });
                }
                break;
            }
            case 'select':
                let selectedItems = eventObj.value;
                const userAddedDefaultEmptyItem = _.last(selectedItems)?.value === null;
                const existedDefaultEmptyItem = _.head(selectedItems)?.value === null;

                // clear default empty item when user pick a item
                if (existedDefaultEmptyItem && _.size(selectedItems) > 1)
                    selectedItems = _.filter(selectedItems, i => i?.value !== null);

                //if default empty item added to tag value. we will clear other items in list
                if (userAddedDefaultEmptyItem && _.size(selectedItems) > 1)
                    selectedItems = _.filter(selectedItems, i => i?.value === null);    
                setTagValue(selectedItems);

                const sysFieldOfThisField = props?.data?.sysField

                if (setSdautoSelectedData &&
                    sysFieldOfThisField === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING_TARGET
                ) {
                    setSdautoSelectedData(prev => {
                        const clonedData = {...prev}
                        return {
                            ...clonedData,
                            [Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING_TARGET]: [...selectedItems]
                        }
                    })
                }

                if (
                    [
                        Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER,
                        Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,
                        Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL,
                        Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING
                    ].includes(sysFieldOfThisField) &&
                    setAIAutoSelectedData
                ) {
                    setAIAutoSelectedData(prev => {
                        let currentData = { ...(prev || {}) };
                        if (
                            sysFieldOfThisField ===
                                Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE &&
                            currentData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER] &&
                            !Utils.isEmptyArray(
                                currentData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER]
                            )
                        ) {
                            let currentSelectedItem =
                                currentData[Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER];
                            let newAiAutoSelectedData = {
                                ...aiAutoSelectedData
                            };
                            newAiAutoSelectedData[
                                Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE
                            ] = selectedItems;

                            let newEventTriggerValue = [];
                            if (!Utils.isEmptyArray(currentSelectedItem)) {
                                let newSelectedItemList = currentSelectedItem.map(tagItem => {
                                    if (
                                        validateShowTagItemEventTrigger(
                                            tagItem,
                                            newAiAutoSelectedData
                                        )
                                    )
                                        return tagItem;
                                    return null;
                                });
                                newSelectedItemList = newSelectedItemList.filter(item => item);
                                newEventTriggerValue = newSelectedItemList;
                            }

                            currentData[
                                Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER
                            ] = newEventTriggerValue;
                        }

                        return {
                            ...currentData,
                            [sysFieldOfThisField]: selectedItems
                        };
                    });
                }

                // AI Telephone parent fields that need to be tracked
                const AI_TELEPHONE_PARENT_FIELDS = [
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD,
                    Constant.SYSTEM_FIELD.CHATGPT_MODEL,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE
                ];

                // Check if this is an AI Telephone form
                const isAITelephoneForm = Utils.isSystemFormAITelephonePrompt(props?.parentForm);
                const isSystemFormAIAssistantPrompt = Utils.isSystemFormAIAssistantPrompt(
                    props?.parentForm
                );
                
                // Update aiTelephoneSelectedData for AI Telephone form
                if (
                    (isAITelephoneForm || isSystemFormAIAssistantPrompt) &&
                    AI_TELEPHONE_PARENT_FIELDS.includes(sysFieldOfThisField) &&
                    setAITelephoneSelectedData
                ) {
                    setAITelephoneSelectedData(prev => {
                        const currentData = { ...(prev || {}) };
                        
                        return {
                            ...currentData,
                            [sysFieldOfThisField]: selectedItems
                        };
                    });
                }

                if (SYSTEM_FIELDS_HAVE_DEPENDENT_QUERY.includes(sysFieldOfThisField)) {
                    const {
                        aiAutoCorporationQueryId,
                        aiAutoProjectQueryId,
                        aiAutoUserQueryId
                    } = getQueryParamsAIAuto();
                    getTagItemsByRelatedSystemFieldValue(
                        aiAutoCorporationQueryId,
                        aiAutoProjectQueryId,
                        aiAutoUserQueryId,
                        sysFieldOfThisField,
                        _.first(selectedItems),
                        props?.setOptionsOfTagField,
                        setIsLoadingInput,
                        (firstRender && props?.detailTicket && props?.detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT),
                        formsInCorporation,
                        fieldsInCorporation,
                        projectsInCorporation,
                        corporationDetail
                    );

                    /**
                     * ai auto reset value when change parent fields.
                     */
                    const PARENT_FIELDS = [Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE ]
                    if (
                       _.includes(PARENT_FIELDS, sysFieldOfThisField)
                    ) {
                        let fieldListData = props?.fieldListDefaultData;
                        let fieldsNeedReset =[
                            Constant.AI_AUTO.SYSTEM_FIELD.AND,
                            Constant.AI_AUTO.SYSTEM_FIELD.OR,
                            Constant.AI_AUTO.SYSTEM_FIELD.EXCLUDE
                        ]

                        if (props?.isDraftMode && props?.isTicketKnowledge && !Utils.isEmptyArray(props?.fieldListData)) {
                            fieldListData = props?.fieldListData;
                        }

                        if(sysFieldOfThisField === Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE) fieldsNeedReset.push(Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE)
                        
                            fieldListData = _.map(fieldListData, fieldData => {
                            if (_.includes(fieldsNeedReset, fieldData?.sysField)) {
                                if (
                                    fieldData?.sysField ===
                                    Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE
                                ) {
                                    if (props?.isDraftMode && props?.isTicketKnowledge && props.setCurrentPanelInitData && sysFieldOfThisField === Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE) {
                                        let listFieldToResetData = [];

                                        fieldListData.map(fieldDataReset => {
                                            if (fieldsNeedReset.includes(fieldDataReset?.sysField)) {
                                                listFieldToResetData.push(fieldDataReset.id);
                                            }
                                        })

                                        props.setCurrentPanelInitData(prev => {
                                            if (!Utils.isEmptyArray(listFieldToResetData)) {
                                                listFieldToResetData.map(fieldResetId => {
                                                    if (prev?.formData && prev?.formData.hasOwnProperty(fieldResetId)) {
                                                        prev['formData'][fieldResetId] = JSON.stringify(
                                                            [Constant.FIELD_UI_SELECT_DEFAULT_ITEM]
                                                        )
                                                    }
                                                })
                                            }

                                            if (prev?.formData && prev?.formData.hasOwnProperty(fieldData?.id)) {
                                                prev['formData'][fieldData?.id] = JSON.stringify(
                                                    [Constant.FIELD_UI_SELECT_DEFAULT_ITEM]
                                                )
                                            }
                     
                                            return prev;
                                        })
                                    }
                                    return {
                                        ...fieldData,
                                        defaultValue: JSON.stringify(
                                           [Constant.FIELD_UI_SELECT_DEFAULT_ITEM]
                                        )
                                    };
                                }

                                return {
                                    ...fieldData,
                                    defaultValue: JSON.stringify([])
                                };
                            }
                            return fieldData;
                        });

                        const andOrExcludeFieldIds = _.map(props?.fieldListDefaultData, field => {
                            if (_.includes(fieldsNeedReset, field?.sysField)) return field?.id;
                            return null;
                        }).filter(i => i);
                        
                        // set edit field list.
                        if (andOrExcludeFieldIds.length > 0) {
                            resetRelatedField = andOrExcludeFieldIds;
                        }

                        if (props?.setFieldListDefaultData)
                            props?.setFieldListDefaultData(fieldListData);
                    }
                }
                newTagValue = selectedItems;
                queryLoadMoreTagItems();
                break;
            default:
                break;
        }
        if (
            props.data.structure.isAutoFill &&
            props.data.structure.settingSelectItem ===
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL
        ) {
            let listItemOfField = props.data.structure.listItem;
            //{orderOfSelectedFields: [],selectedTicketIdOfMasterForm: {},currentFieldChangeInfo:{fieldId:id, index: index, typeOfChange: ''}}
            let autoFillObjectClone = cloneDeep(props.autoFillObject);
            let orderOfSelectedFields = Utils.isEmptyArray(
                autoFillObjectClone.orderOfSelectedFields
            )
                ? []
                : autoFillObjectClone.orderOfSelectedFields;
            let selectedTicketIdOfMasterForm = Utils.isEmptyArray(
                autoFillObjectClone.selectedTicketIdOfMasterForm
            )
                ? {}
                : autoFillObjectClone.selectedTicketIdOfMasterForm;
            let currentFieldChangeInfo = {};
            currentFieldChangeInfo.fieldId = props.name;
            //Bỏ chọn giá trị tự động input
            if (
                (Utils.isEmptyArray(newTagValue) || newTagValue[0] === null) &&
                !orderOfSelectedFields.includes(props.name)
            ) {
                return;
            }
            //Bỏ toàn bộ Item
            if (newTagValue.length === 0) {
                currentFieldChangeInfo.typeOfChange = 'changeItem';
                currentFieldChangeInfo.index = orderOfSelectedFields.findIndex(
                    id => id == props.name
                );
                selectedTicketIdOfMasterForm[`${props.name}`] = [];
                autoFillObjectClone.currentFieldChangeInfo = currentFieldChangeInfo;
                autoFillObjectClone.orderOfSelectedFields = orderOfSelectedFields.filter(
                    id => id != props.name
                );
                autoFillObjectClone.selectedTicketIdOfMasterForm = selectedTicketIdOfMasterForm;
                props.setAutoFillObject({ ...autoFillObjectClone });
                resetItemList(
                    selectedTicketIdOfMasterForm,
                    autoFillObjectClone.orderOfSelectedFields
                );
                return;
            }
            let selectedItemIdList = [];
            newTagValue.forEach(item => selectedItemIdList.push(item.value));
            selectedTicketIdOfMasterForm[`${props.name}`] = getListTicketOfItemList(
                listItemOfField,
                selectedItemIdList
            );
            let indexOfFiledInSelectedOrder;
            if (orderOfSelectedFields.includes(props.name)) {
                indexOfFiledInSelectedOrder = orderOfSelectedFields.findIndex(
                    id => id == props.name
                );
            } else {
                indexOfFiledInSelectedOrder = orderOfSelectedFields.push(props.name);
            }
            currentFieldChangeInfo.index = indexOfFiledInSelectedOrder;
            currentFieldChangeInfo.typeOfChange = checkContainsArray(currentTagValue, newTagValue)
                ? 'addItem'
                : 'changeItem';
            autoFillObjectClone.currentFieldChangeInfo = currentFieldChangeInfo;
            autoFillObjectClone.orderOfSelectedFields = orderOfSelectedFields;
            autoFillObjectClone.selectedTicketIdOfMasterForm = selectedTicketIdOfMasterForm;
            props.setAutoFillObject({ ...autoFillObjectClone });
            return;
        }
    };

    const onFocusHandler = (e, eventObj) => {
        e.preventDefault();
        switch (eventObj?.type) {
            case Constant.TAG_FIELD_OPTION_TYPE.CHECKBOX:
            case Constant.TAG_FIELD_OPTION_TYPE.RADIO: {
                //todo after
                break;
            }
            case Constant.TAG_FIELD_OPTION_TYPE.SELECT: {
                setIsLoadingInput(true);
                queryLoadMoreTagItems().finally(() => {
                    setIsLoadingInput(false);
                });
                break;
            }
            default:
                break;
        }
    };

    const getError = (errorList, name) => {
        if(Utils.isEmptyArray(errorList)) {
            return '';
        }

        if(!errorList[name]) {
            return '';
        }

        if (
            { ...props }?.data?.sysField ===
                Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER &&
            !isShowFieldEventTypeChatThread(aiAutoSelectedData)
        ) {
            return '';
        }

        if (
            { ...props }?.data?.sysField ===
                Constant.AI_AUTO.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS &&
            !isShowFieldAIPDFPageSplitStatus(aiAutoSelectedData)
        ) {
            return '';
        }

         if (
            { ...props }?.data?.sysField ===
                Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT &&
            !isShowReasoningEffortField(aiAutoSelectedData)
        ) {
            return '';
        }

        return errorList[name].message;
    }

    const filterSuggestionInputChip = createFilterOptions({
        matchFrom: 'any',
        stringify: option => `${option?.title}`
    });

    const getQueryParamsAIAuto = () =>{
        let aiAutoCorporationQueryId = corporationDetail?.id
        let aiAutoProjectQueryId = projectDetail?.id
        let aiAutoUserQueryId = userDetail?.id
        let aiAutoProjectDetail = projectDetail
        let aiAutoCorporationDetail = corporationDetail

        if (props?.detailTicket && props?.detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT) {
            if (!Utils.isEmptyString(props?.detailTicket?.affiliationOrganization))
                aiAutoCorporationQueryId = props?.detailTicket?.affiliationOrganization;
            if (!Utils.isEmptyString(props?.detailTicket?.affiliationProject))
                aiAutoProjectQueryId = props?.detailTicket?.affiliationProject;
            if (!Utils.isEmptyString(props?.detailTicket?.creator))
                aiAutoUserQueryId = props?.detailTicket?.creator;
            if (!Utils.isEmptyObject(props?.ticketAffiliationProject))
                aiAutoProjectDetail = props?.ticketAffiliationProject;
            if (!Utils.isEmptyObject(props?.corporationAffiliationTicket))
                aiAutoCorporationDetail = props?.corporationAffiliationTicket;
        }

        return {
            aiAutoCorporationQueryId,
            aiAutoProjectQueryId,
            aiAutoUserQueryId,
            aiAutoProjectDetail,
            aiAutoCorporationDetail
        }
    }

    // Eff update value of tag field related
    useEffect(() => {
        if (!Utils.isEmptyObject(aiAutoSelectedData)) {
            switch ({ ...props }?.data?.sysField) {
                case Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER: {
                    if (!isShowFieldEventTypeChatThread(aiAutoSelectedData)) {
                        if (firstRender) {
                            setTagValue(prev => {
                                let itemList = [...prev];
                                itemList = itemList.map(tagItem => {
                                    return { ...tagItem, isShow: false };
                                });
                                return itemList;
                            });
                        } else {
                            setTagValue([]);
                        }
                        setValidateError({
                            isError: false,
                            message: ''
                        });
                        clearErrors({ ...props }?.name);
                        setFirstRender(true);
                        return;
                    }

                    let isUpdateTriggerField = false;
                    setTagValue(prev => {
                        let itemList = [...prev];
                        itemList = itemList.map(tagItem => {
                            let isShow = validateShowTagItemEventTypeChatThread(
                                tagItem,
                                aiAutoSelectedData
                            );
                            return { ...tagItem, isShow };
                        });
                        itemList = itemList.filter(item => item.isShow);
                        if (prev?.length !== itemList?.length) {
                            isUpdateTriggerField = true;
                        }

                        return itemList;
                    });

                    if (isUpdateTriggerField) {
                        if (
                            !props?.listFieldEdited?.includes(props?.name) &&
                            props?.setListFieldEdited
                        ) {
                            props?.setListFieldEdited([...props.listFieldEdited, props?.name]);
                        }
                    }
                    break;
                }
                case Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER: {
                    // Skip trigger when not init done
                    // Fix for https://new.redmine.ominext.com/issues/214042 case 1
                    if (
                        aiAutoSelectedData.hasOwnProperty(
                            Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER
                        ) &&
                        !aiAutoSelectedData.hasOwnProperty(
                            Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE
                        )
                    ) {
                        return;
                    }

                    setTagValue(prev => {
                        let currentSelectedItem = [...prev];
                        if (!Utils.isEmptyArray(currentSelectedItem)) {
                            let newSelectedItemList = currentSelectedItem.map(tagItem => {
                                if (validateShowTagItemEventTrigger(tagItem, aiAutoSelectedData))
                                    return tagItem;
                                return null;
                            });
                            newSelectedItemList = newSelectedItemList.filter(item => item);
                            return newSelectedItemList;
                        }
                        return [];
                    });
                    break;
                }
                case Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT: {
                    const chatGptModelName = getSelectedChatGptModelName();
                    const isInitializedReasoningModel = isInitializedReasoningModelRef.current;
                    const isChatGptModelChanged =
                        isInitializedReasoningModel &&
                        previousChatGptModelInReasoningField.current !== chatGptModelName;
                    previousChatGptModelInReasoningField.current = chatGptModelName;
                    isInitializedReasoningModelRef.current = true;

                    if (!isShowReasoningEffortField(aiAutoSelectedData)) {
                        if (!firstRender) {
                            // console.log({chatGptModelValue, chatGptModelName})
                            const defaultReasoningOption = tagList?.find(
                                option =>
                                    option?.sysField ===
                                    OpenAiUtil.defaultReasoningEffort(chatGptModelName, true)
                            );

                            setTagValue([defaultReasoningOption]);
                        }
                        setValidateError({
                            isError: false,
                            message: ''
                        });
                        props?.clearErrors({ ...props }?.name);
                        setFirstRender(true)
                        return;
                    }
                    // Filter tagList based on selected chatgpt_model and check/update tagValue
                    setTagList(prev => {
                        let filteredList = prev.map(tagItem => {
                            let isShow = validateShowTagItemReasoningEffort(tagItem, aiAutoSelectedData);
                            return { ...tagItem, isShow };
                        });
                        // Check if current tagValue is valid for the new model, reset to model default if invalid
                        setTagValue(currentTagValue => {
                            if (isChatGptModelChanged && chatGptModelName) {
                                const defaultReasoningOption = filteredList.find(
                                    option =>
                                        option?.sysField ===
                                        OpenAiUtil.defaultReasoningEffort(chatGptModelName, true) &&
                                        validateShowTagItemReasoningEffort(option, aiAutoSelectedData)
                                );
                                if (defaultReasoningOption) {
                                    return [defaultReasoningOption];
                                }
                                return [];
                            }

                            // console.log('--- currentTagValue', currentTagValue)
                            if (Utils.isEmptyArray(currentTagValue)) return currentTagValue;
                            let currentSelectedItem = [...currentTagValue];

                             let isValid = validateShowTagItemReasoningEffort(
                                currentSelectedItem[0],
                                aiAutoSelectedData
                            );
                            if (!isValid && chatGptModelName) {
                                // Reset to default if current value is invalid
                                const defaultReasoningOption = filteredList.find(
                                    option =>
                                        option?.sysField ===
                                        OpenAiUtil.defaultReasoningEffort(chatGptModelName, true) &&
                                        validateShowTagItemReasoningEffort(option, aiAutoSelectedData)
                                );
                                if (defaultReasoningOption) {
                                    return [defaultReasoningOption];
                                }
                                // If default option is not available, return empty array
                                return [];
                            }

                            return currentSelectedItem;
                        });

                        return filteredList;
                    });
                    break;
                }
                default:
            }
        }
    }, [aiAutoSelectedData, firstRender, mustCleaningTagList]);

    // Eff update value of tag field sdauto related
    useEffect(() => {
        if (Utils.isEmptyObject(sdautoSelectedData)) return;
        const listenSysField = { ...props }?.data?.sysField;
        if (listenSysField === Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING_TARGET) {
            if (!isShowFieldCallApiTarget(sdautoSelectedData)) {
                setValidateError({
                    isError: false,
                    message: ''
                });
                clearErrors({ ...props }?.name);
                return;
            }
        }
    }, [sdautoSelectedData, firstRender]);

    // Eff update value of tag field AI Telephone trigger condition related
    useEffect(() => {
        const listenSysField = props?.data?.sysField;
        const isAITelephoneForm =Utils.isSystemFormAITelephonePrompt(props?.parentForm);
        
        if (listenSysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION && isAITelephoneForm) {
            // Update tagList visibility based on prompt type selection
            setTagList(prev => {
                let itemList = [...prev];
                itemList = itemList.map(tagItem => {
                    let isShow = validateShowTagItemTriggerCondition(tagItem, aiTelephoneSelectedData);
                    return { ...tagItem, isShow };
                });
                return itemList;
            });
            
            // Filter out hidden items from current selection
            setTagValue(prev => {
                if (Utils.isEmptyArray(prev)) return prev;
                
                let filteredValue = prev.filter(tagItem => 
                    validateShowTagItemTriggerCondition(tagItem, aiTelephoneSelectedData)
                );
                
                // If selection changed, clear errors
                if (prev.length !== filteredValue.length) {
                    setValidateError({ isError: false, message: '' });
                    if (clearErrors) clearErrors(props?.name);
                }
                
                return filteredValue;
            });
        }
    }, [aiTelephoneSelectedData, firstRender]);

    useEffect(() => {
        const checkMCPServerFieldVisibility = async () => {
            if ({ ...props }?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING) {
                let isNewTicket = (isAddNewTicket || isDuplicate);
                let corpData = corporationDetail;
                if (!isNewTicket && corporationDetail?.id !== detailTicket?.affiliationOrganization) {
                    corpData = await getCorporationById(null, detailTicket?.affiliationOrganization);
                }
                const isShowMCPServerField = isShowMCPServerSettingField(
                    corpData, 
                    detailTicket, 
                    isNewTicket
                );
                
                setShowMCPServerField(isShowMCPServerField);
            }
        };
        
        checkMCPServerFieldVisibility();
    }, [corporationDetail?.id, detailTicket?.affiliationOrganization, isAddNewTicket, isDuplicate, props?.data?.sysField]);

    // Show/hide field_kibana_analysis (分析機能) - CR-297430
    // Same as MCP field: new/duplicate ticket -> corp + project in use; existing ticket -> corp + project of the ticket
    // (ticket shared from another corp/project is checked by its own settings).
    useEffect(() => {
        const checkKibanaAnalysisFieldVisibility = async () => {
            if (props?.data?.sysField !== Constant.SYSTEM_FIELD.KIBANA_ANALYSIS) return;
            try {
                let isNewTicket = (isAddNewTicket || isDuplicate);
                let corpData = corporationDetail;
                let projectData = projectDetail;
                if (!isNewTicket) {
                    if (detailTicket?.affiliationOrganization && corporationDetail?.id !== detailTicket?.affiliationOrganization) {
                        corpData = await getCorporationById(null, detailTicket?.affiliationOrganization);
                    }
                    if (detailTicket?.affiliationProject && projectDetail?.id !== detailTicket?.affiliationProject) {
                        projectData = props?.affiliationProjectOfTicket?.id === detailTicket?.affiliationProject
                            ? props?.affiliationProjectOfTicket
                            : await getProjectById(null, detailTicket?.affiliationProject);
                    }
                }
                setShowKibanaAnalysisField(isShowKibanaAnalysisField({
                    corporationDetail: corpData,
                    projectInuseDetail: projectData
                }));
            } catch (err) {
                console.error('Error checking kibana analysis field visibility:', err);
                setShowKibanaAnalysisField(false);
            }
        };

        checkKibanaAnalysisFieldVisibility();
    }, [
        corporationDetail?.id,
        projectDetail?.id,
        detailTicket?.affiliationOrganization,
        detailTicket?.affiliationProject,
        props?.affiliationProjectOfTicket?.id,
        isAddNewTicket,
        isDuplicate,
        props?.data?.sysField
    ]);
    if ({ ...props }?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT) {
        if (!isShowReasoningEffortField(aiAutoSelectedData)) return <></>;
    }

    // Show/hide field_event_type_chat_thread field
    if ({ ...props }?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER) {
        if (!isShowFieldEventTypeChatThread(aiAutoSelectedData)) {
            return null;
        } 
    }

    // Show/hide ai_pdf_page_split_status field
    if ({ ...props }?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS) {
        if (!isShowFieldAIPDFPageSplitStatus(aiAutoSelectedData)) {
            return null;
        }
    }

    if ({ ...props }?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING) {
        // Show loading or hide while checking
        if (showMCPServerField === null) {
            return <></>;
        }
        if (!showMCPServerField) {
            return <></>;
        }
    }

    // Show/hide field_kibana_analysis (分析機能) - CR-297430
    // null = still checking, false = hidden (see checkKibanaAnalysisFieldVisibility)
    if ({ ...props }?.data?.sysField === Constant.SYSTEM_FIELD.KIBANA_ANALYSIS) {
        if (!showKibanaAnalysisField) {
            return <></>;
        }
    }

    const sortOptionsByMcpGroup = listOptions => {
        const isPersonalItem = item => {
            const id = item?.value;
            if (Utils.getPrefixOfId(id) !== Constant.ID_PREFIX.MCP_CATALOG) return false;
            const { prefix } = parseLocalMcpScope(id);
            return prefix === LOCAL_MCP_USER_PREFIX;
        };
        const projectItems = listOptions.filter(item => !isPersonalItem(item));
        const personalItems = listOptions.filter(item => isPersonalItem(item));

        return [...projectItems, ...personalItems];
    };

    const filterObjectForPersonalConnector = listOptionsParams => {
        let listOptions = cloneDeep(listOptionsParams);
        if (props?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING) {
            listOptions = sortOptionsByMcpGroup(listOptions);
            if (
                Utils.isEmptyObject(props?.parentForm) ||
                props?.parentForm?.definition !== Constant.FORM_DEFINITION.SYSTEM
            ) {
                return listOptions.filter(
                    item => !item.value?.includes(Constant.ID_PREFIX.OPENAI_CONNECTOR_PERSONAL)
                );
            }

            let formName = Utils.convertJSONDataToObject(props?.parentForm?.name);
            let formNameJP = formName?.jp?.text;
            if (formNameJP !== Constant.SYSTEM_FORM_NAME.SYSTEM_AI_CHAT_PROMPT) {
                return listOptions.filter(
                    item => !item.value?.includes(Constant.ID_PREFIX.OPENAI_CONNECTOR_PERSONAL)
                );
            }
        }

        return _.filter(listOptions, (tag) => tag?.isShow !== false)
    };

    const filterOptionsForPersonalConnector = optionParam => {
        let option = cloneDeep(optionParam);
        if (props?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING) {
            if (
                Utils.isEmptyObject(props?.parentForm) ||
                props?.parentForm?.definition !== Constant.FORM_DEFINITION.SYSTEM
            ) {
                return true;
            }
            let formName = Utils.convertJSONDataToObject(props?.parentForm?.name);
            let formNameJP = formName?.jp?.text;
            if (formNameJP !== Constant.SYSTEM_FORM_NAME.SYSTEM_AI_CHAT_PROMPT) {
                return !option?.value?.includes(Constant.ID_PREFIX.OPENAI_CONNECTOR_PERSONAL);
            }
        }

        return true;
    };

    const groupByOptions = option => {
        let groupBy = false;
        if (props?.data?.sysField === Constant.SYSTEM_FIELD.BUSINESS_APP_USE_RANGE) {
            const prefixId = Utils.getPrefixOfId(option?.value);
            if (prefixId === Constant.ID_PREFIX.PROJECT) {
                groupBy = trI18n('USER04BTN007');
            } else {
                groupBy = trI18n('LABEL-OTHERS');
            }
        }

        if(props?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING) {
            const id = option?.value;
            if (Utils.getPrefixOfId(id) !== Constant.ID_PREFIX.MCP_CATALOG) {
                return groupBy = trI18n('MCP_SERVER_SETTING_FOR_PROJECT');
            }
            const { prefix } = parseLocalMcpScope(id);
            const isPersonal = prefix === LOCAL_MCP_USER_PREFIX;
            groupBy = isPersonal ? trI18n('MCP_SERVER_SETTING_FOR_PERSONAL') : trI18n('MCP_SERVER_SETTING_FOR_PROJECT');
        }
        return groupBy;
    };

    // Render checkbox only mode (without field label)
    if (props.data?.structure?.isOnlyCheckbox) {
        return (
            <div className="form-addTicket only-checkbox-field" style={{ marginTop: 8, marginBottom: 8 }}>
                <div className="form-addTicket-input" data-cy="render-field-menu-tag 1">
                    <div className="input-item-list">
                        <div className="col-flex">
                            {tagList.filter(item => item.isShow !== false).map((item, i) => (
                                <div className="col-checkbox" key={item?.id || i}>
                                    <FormControlLabel
                                        className="tag-item custom-checkbox"
                                        control={
                                            <Checkbox
                                                onChange={e => {
                                                    if (isDisableField) return;
                                                    setFirstRender(false);
                                                    onClickHandler({
                                                        type: 'checkBox',
                                                        value: e
                                                    });
                                                    if (props?.setIsEdited) {
                                                        props?.setIsEdited(true);
                                                        if (!props?.listFieldEdited?.includes(props?.name)) {
                                                            props?.setListFieldEdited([
                                                                ...props.listFieldEdited,
                                                                props?.name
                                                            ]);
                                                        }
                                                        if (props?.setOnChangeEdit) {
                                                            props?.setOnChangeEdit(!props.onChangeEdit);
                                                        }
                                                    }
                                                }}
                                                value={item.value}
                                                disabled={
                                                    props.data.structure.publicForCustomer == 2 ||
                                                    item.isDeleted ||
                                                    !Utils.isEmptyString(props.detailTicket?.deletedAt) ||
                                                    props.hasEditFieldPermissions === false
                                                }
                                                icon={
                                                    <UnCheckIconWhite
                                                        isDiabled={
                                                            props.data.structure.publicForCustomer ===
                                                                Constant.SETTING_FORM_DEFAULT.READ_ONLY ||
                                                            item.isDeleted ||
                                                            !Utils.isEmptyString(props.detailTicket?.deletedAt)
                                                        }
                                                    />
                                                }
                                                checkedIcon={isDisableField ? <DisabelCheckedIcon /> : <CheckedIcon />}
                                                checked={isCheckedItem(item.value)}
                                            />
                                        }
                                        label={
                                            <OverFlowTooltipWithTabsMui value={getDisplayTitle(item)} />
                                        }
                                        data-cy="render-field-tag-checkbox-only"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const isAIOperatorPromptField =
        props?.data?.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.AI_OPERATOR_PROMPT;
    const shouldHideTagDropdownIcon = isAIOperatorPromptField;
    const shouldHideChipInnerInput = isAIOperatorPromptField && !Utils.isEmptyArray(tagValue);
    const selectInputClassName = `form-control form-control--wrapSelect form-control--hg40${
        shouldHideTagDropdownIcon ? ' form-control--noSelectArrow' : ''
    }`;

    let className = '';
    if (
        [
            TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER,
            TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALLER_LANGUAGE
        ].includes(props.data?.sysField)
    ) {
        className = 'width-50-left';
    } else if (
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.RECEIVER_LANGUAGE === props.data?.sysField
    ) {
        className = 'width-50-right';
    }

    return (
        <>
            <div className={`form-addTicket ${className}`}>
                <div className="cell-prod-status gap-8">
                    {props?.isTooltipTitle ? 
                        <RenderTooltipTitles {...props}/> :
                        <label className="form-addTicket-label w-f100">{props?.label} {props.data.structure.required && <span className="required">*</span>}</label>
                    }
                    {props?.isShowIconCopyFieldId && (
                        <Tooltip title={props?.data.id} placement='top' arrow>
                            <img
                                src="/assets/image/icon-copy.svg"
                                alt="copy"
                                onClick={() => navigator.clipboard.writeText(props?.data.id)}
                            />
                        </Tooltip>
                    )}
                </div>
                
                <div className="form-addTicket-input" data-cy="render-field-menu-tag 2">
                    <div className="input-item-list"  style={isLoadingInput ? { position: 'relative'} : undefined} >
                        {isLoadingInput && (
                            <div className="loading-overlay">
                                <CircularProgress  color="primary" size={14}/>
                            </div>
                        )}
                        

                   
                        {(enableShowMore ||
                            props.data.structure.optionType ===
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT) &&
                            props.data.structure.isMultiple &&
                            props?.data?.structure?.UI !== Constant.FIELD_UI.TEXT_WITH_CHIP && (
                                <div
                                    className={`${
                                        isDisableField ? 'class_disabled autoComplete-disable' : ''
                                    }`}
                                >
                                    <Autocomplete
                                        PopperComponent={PopperComponentMemo}
                                        multiple
                                        filterSelectedOptions
                                        sx={{
                                            maxHeight: 10
                                        }}
                                        options={filterObjectForPersonalConnector(tagList)}
                                        getOptionLabel={option => getDisplayTitle(option) || ''}
                                        disableCloseOnSelect
                                        getOptionSelected={(option, selectedValue) =>
                                            option.title === selectedValue.title &&
                                            option.value === selectedValue.value
                                        }
                                        groupBy={option => groupByOptions(option)}
                                        value={tagValue}
                                        disabled={isDisableField}
                                        onChange={(e, newValue) => {
                                            if (isDisableField) return;
                                            setFirstRender(false);
                                            onClickHandler({ type: 'select', value: newValue });
                                            if (props?.setIsEdited) {
                                                props?.setIsEdited(true);
                                                if (
                                                    !props?.listFieldEdited?.includes(props?.name)
                                                ) {
                                                    props?.setListFieldEdited([
                                                        ...props.listFieldEdited,
                                                        props?.name
                                                    ]);
                                                }
                                                if (props?.setOnChangeEdit) {
                                                    props?.setOnChangeEdit(!props.onChangeEdit);
                                                }
                                            }
                                        }}
                                        onFocus={e => {
                                            if (isDisableField) return;

                                            onFocusHandler(e, {
                                                type: Constant.TAG_FIELD_OPTION_TYPE.SELECT
                                            });
                                        }}
                                        renderTags={(value, getTagProps) => {
                                            return value.map((option, index) => {
                                                const { key, ...tagProps } = getTagProps({ index });
                                                return (
                                                    <Chip
                                                        key={key}
                                                        label={getDisplayTitle(option)}
                                                        {...tagProps}
                                                        onDelete={isDisableField ? null : tagProps.onDelete}
                                                    />
                                                );
                                            });
                                        }}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                className={selectInputClassName}
                                                error={validateError?.isError}
                                            />
                                        )}
                                        renderOption={option => (
                                            <OverFlowTooltipWithTabsMui value={getDisplayTitle(option)} />
                                        )}
                                        ListboxProps={{
                                            style: { maxHeight: 200, overflow: 'auto' } // Ensure scrolling
                                        }}
                                    />
                                </div>
                            )}
                        {(enableShowMore ||
                            props.data.structure.optionType ===
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT) &&
                            !props.data.structure.isMultiple &&
                            props?.data?.structure?.UI !== Constant.FIELD_UI.TEXT_WITH_CHIP && (
                                <div
                                    className={`${
                                        isDisableField ? 'class_disabled autoComplete-disable' : ''
                                    }`}
                                >
                                    <Autocomplete
                                        PopperComponent={PopperComponentMemo}
                                        options={_.filter(tagList, (tag, idx)=> {
                                            return tag?.isShow
                                        })}
                                        sx={{
                                            maxHeight: 10
                                        }}
                                        getOptionLabel={option => getDisplayTitle(option) || ''}
                                        value={{ ...tagValue[0] }}
                                        getOptionSelected={(option, selectedValue) => {
                                            return (
                                                option.title === selectedValue.title &&
                                                option.value === selectedValue.value
                                            );
                                        }}
                                        disabled={isDisableField}
                                        onChange={(e, newValue) => {
                                            if (isDisableField) return;
                                            onClickHandler({ type: 'select', value: [newValue] });
                                            if (props?.setIsEdited) {
                                                props?.setIsEdited(true);
                                                if (
                                                    !props?.listFieldEdited?.includes(props?.name)
                                                ) {
                                                    props?.setListFieldEdited([
                                                        ...props.listFieldEdited,
                                                        ...resetRelatedField,
                                                        props?.name
                                                    ]);
                                                }
                                                if (props?.setOnChangeEdit) {
                                                    props?.setOnChangeEdit(!props.onChangeEdit);
                                                }
                                            }
                                        }}
                                        onFocus={(e,newValue)=> {
                                            if (isDisableField) return;

                                            onFocusHandler(e, {
                                                type: Constant.TAG_FIELD_OPTION_TYPE.SELECT
                                            });
                                        }}
                                        renderInput={params => {
                                            if (props?.data?.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER) {
                                                const selectedTitle = !Utils.isEmptyArray(tagValue) ? tagValue[0]?.title : '';
                                                if (selectedTitle) {
                                                    params.inputProps = {
                                                        ...params.inputProps,
                                                        onSelect: (e) => {
                                                            e.target.selectionStart = e.target.selectionEnd;
                                                            e.target.scrollLeft = 0;
                                                        },
                                                        onScroll: (e) => {
                                                            e.target.scrollLeft = 0;
                                                        },
                                                        style: {
                                                            ...params.inputProps?.style,
                                                            width: 0,
                                                            minWidth: 0,
                                                            padding: 0,
                                                            opacity: 0,
                                                            position: 'absolute'
                                                        }
                                                    };
                                                    params.InputProps = {
                                                        ...params.InputProps,
                                                        startAdornment: (
                                                            <div style={{
                                                                overflow: 'hidden',
                                                                maxWidth: 'calc(100% - 4px)',
                                                                pointerEvents: 'none',
                                                                paddingLeft: '14px'
                                                            }}>
                                                                <OverflowTooltipValue title={selectedTitle} />
                                                            </div>
                                                        )
                                                    };
                                                }
                                            }

                                            return (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    className={selectInputClassName}
                                                    error={validateError?.isError}
                                                />
                                            );
                                        }}
                                        renderOption={option => (
                                            <OverFlowTooltipWithTabsMui value={getDisplayTitle(option)} />
                                        )}
                                        ListboxProps={{
                                            style: { maxHeight: 200, overflow: 'auto' } // Ensure scrolling
                                        }}
                                    />
                                </div>
                            )}
                        {!enableShowMore &&
                            props.data.structure.optionType !==
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT &&
                            props.data.structure.isMultiple && props?.data?.structure?.UI  !== Constant.FIELD_UI.TEXT_WITH_CHIP && (
                            <div className="col-flex" style={{ flexDirection: props?.isMaximizedPanel ? 'inherit' : 'column' }}>
                                    {tagList.filter(item => item.isShow !== false).slice(0, numOfRecordDisplay).map((item, i) => {
                                        return <div className="col-checkbox" key={item?.id || i}>
                                            <FormControlLabel
                                                className="tag-item custom-checkbox"
                                                control={
                                                    <Checkbox
                                                        onChange={e =>
                                                            {
                                                            if (isDisableField) return;
                                                            setFirstRender(false);
                                                            onClickHandler({
                                                                type: 'checkBox',
                                                                value: e
                                                            })}
                                                        }
                                                        value={item.value}
                                                        disabled={
                                                            props.data.structure
                                                                .publicForCustomer == 2 ||
                                                            item.isDeleted ||
                                                            !Utils.isEmptyString(
                                                                props.detailTicket?.deletedAt
                                                            ) || props.hasEditFieldPermissions === false 
                                                        }
                                                        icon={
                                                            <UnCheckIconWhite
                                                                isDiabled={
                                                                    props.data.structure
                                                                        .publicForCustomer ===
                                                                        Constant.SETTING_FORM_DEFAULT.READ_ONLY ||
                                                                    item.isDeleted ||
                                                                    !Utils.isEmptyString(
                                                                        props.detailTicket
                                                                            ?.deletedAt
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        checkedIcon={isDisableField ? <DisabelCheckedIcon /> : <CheckedIcon />}
                                                        checked={isCheckedItem(item.value)}
                                                    />
                                                }
                                                label={
                                                    <OverFlowTooltipWithTabsMui 
                                                        value={getDisplayTitle(item)} 
                                                    />
                                                }
                                                data-cy="render-field-tag-checkbox"
                                            />
                                        </div>
                                    })}{' '}
                                </div>
                            )}
                        {!enableShowMore &&
                            props.data.structure.optionType !==
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT &&
                            !props.data.structure.isMultiple &&
                            (props.data.structure.settingSelectItem !==
                                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL ||
                                !props.data.structure.isAutoFill) && props?.data?.structure?.UI  !== Constant.FIELD_UI.TEXT_WITH_CHIP && (
                                <RadioGroup
                                    row
                                    aria-label=""
                                    name="radio-buttons-group"
                                    control={props.control}
                                    onChange={e => {
                                        setFirstRender(false)
                                       }
                                    }
                                    onClick={e=> {
                                        if (isDisableField) return;
                                        onClickHandler({ type: 'radio', value: e })
                                    }}
                                >
                                    {tagList.filter(item => item.isShow !== false).slice(0, numOfRecordDisplay).map((item, i) => (
                                        <FormControlLabel
                                            value={item.value}
                                            className="tag-item custom-radio"
                                            control={
                                                <Radio
                                                    disabled={
                                                        isDisableField 
                                                    }
                                                    checked={
                                                        i === getDefaultChecked() ? true : false
                                                    }
                                                />
                                            }
                                            label={
                                                <OverFlowTooltipWithTabsMui 
                                                    value={getDisplayTitle(item)} 
                                                />
                                            }
                                        />
                                    ))}
                                </RadioGroup>
                            )}
                        {!enableShowMore &&
                            props.data.structure.optionType !==
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT &&
                            !props.data.structure.isMultiple &&
                            props.data.structure.isAutoFill &&
                            props.data.structure.settingSelectItem ===
                                Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL && props?.data?.structure?.UI !== Constant.FIELD_UI.TEXT_WITH_CHIP && (
                                <RadioGroup
                                    row
                                    aria-label=""
                                    name="radio-buttons-group"
                                    onChange={e => {
                                        if (isDisableField) return;
                                        setFirstRender(false)
                                        onClickHandler({ type: 'radio', value: e })}
                                    }
                                    onClick={e=>{
                                        if (isDisableField) return;
                                        onClickHandler({ type: 'radio', value: e }) 
                                    }}
                                >
                                    {tagList.filter(item => item.isShow !== false).slice(0, numOfRecordDisplay).map((item, i) => (
                                        <FormControlLabel
                                            value={item.value}
                                            className="tag-item custom-radio"
                                            control={
                                                <Radio
                                                    disabled={
                                                        isDisableField 
                                                    }
                                                    checked={item.value === tagValue[0]?.value}
                                                />
                                            }
                                            label={
                                                <OverFlowTooltipWithTabsMui 
                                                    value={getDisplayTitle(item)} 
                                                />
                                            }
                                        />
                                    ))}
                                </RadioGroup>
                            )}
                        {
                           ( !enableShowMore && props?.data?.structure?.UI === Constant.FIELD_UI.TEXT_WITH_CHIP) &&
                            <>
                                <div className='searchOptionBody'>
                                    <Autocomplete
                                        className={`search-option-tag-content tag-field-chip-input with-chip-auto mt-2 ${
                                                shouldHideTagDropdownIcon ? 'no-select-arrow' : ''
                                            } ${
                                                shouldHideChipInnerInput
                                                    ? 'hide-chip-inner-input'
                                                    : ''
                                            } ${
                                                isDisableField
                                                    ? 'class_disabled autoComplete-disable'
                                                    : ''
                                            }`}
                                        PopperComponent={({ style, ...props3 }) => (
                                        <Popper
                                            {...props3}
                                            style={{ ...style }} // width is passed in 'style' prop
                                            className="selectDrop tag-field-multi-select"
                                        />
                                        )}
                                        groupBy={option => groupByOptions(option)}
                                        multiple
                                        disableCloseOnSelect
                                        filterSelectedOptions={true}
                                        ListboxProps={{ style: { maxHeight: 350, overflow: 'auto' } }}
                                        sx={{
                                            maxHeight: 10
                                        }}
                                        filterOptions={filterSuggestionInputChip}
                                        getOptionLabel={option => getDisplayTitle(option) || ''}
                                        getOptionSelected={(option, selectedValue) => {
                                            return (
                                                option?.title === selectedValue?.title &&
                                                option?.value === selectedValue?.value
                                            );
                                        }}
                                        options={
                                            props?.data?.sysField !== Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING
                                                ? (tagList || [])?.filter(tag => tag?.isShow)
                                                : sortOptionsByMcpGroup(tagList).filter(tag => filterOptionsForPersonalConnector(tag) && tag?.isShow !== false)
                                        }
                                        value={tagValue}
                                        onChange={(e, newValue) =>{
                                            if (isDisableField) return;
                                            onClickHandler({ type: 'select', value: newValue })
                                            if (props?.setIsEdited) {
                                                props?.setIsEdited(true);
                                                if(!props?.listFieldEdited?.includes(props?.name)){
                                                    props?.setListFieldEdited([...props.listFieldEdited,props?.name])
                                                }
                                                if(props?.setOnChangeEdit){
                                                    props?.setOnChangeEdit(!props.onChangeEdit)
                                                }
                                            }
                                        } 
                                    }
                                        disabled={isDisableField}
                                        renderTags={(values, getTagProps) => {
                                            const orderedValues =
                                                props?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING
                                                    ? sortOptionsByMcpGroup(values)
                                                    : values;
                                            return orderedValues.map((option, displayIndex) => {
                                                const originalIndex = values.findIndex(
                                                    v =>
                                                        v?.value === option?.value &&
                                                        v?.title === option?.title
                                                );
                                                const index = originalIndex !== -1 ? originalIndex : displayIndex;
                                                const { key, ...tagProps } = getTagProps({ index });
                                                const chipLabel = getDisplayTitle(option);
                                                
                                                const hasShareLink = option?.shareLink && option?.shareLink.trim() !== '';

                                                if (hasShareLink) {
                                                    const handleClickShareLink = async (e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        try {
                                                            document.body.style.cursor = 'wait';
                                                            
                                                            const {
                                                                orgDomain: affiliationOrganizationDomain,
                                                                projectId: affiliationProject,
                                                                ticketId: ticketIdOfUrl,
                                                                withMessage
                                                            } = await Utils.extractShareLinkInfo(option?.shareLink);
                                                            
                                                            // Validate required fields from share link
                                                            if (!ticketIdOfUrl || !affiliationProject || !affiliationOrganizationDomain) {
                                                                document.body.style.cursor = 'default';
                                                                console.error('Invalid share link - missing required fields:', {
                                                                    ticketId: ticketIdOfUrl,
                                                                    projectId: affiliationProject,
                                                                    orgDomain: affiliationOrganizationDomain
                                                                });
                                                                setIsOpenAccessDeniedPopup(true);
                                                                return;
                                                            }
                                                            const projectInuseId = projectDetail.id || localStorageUtil.getSelectedProjectId();
                                                            await openShareLinkTicket(
                                                                props?.API,
                                                                ticketIdOfUrl,
                                                                affiliationProject,
                                                                affiliationOrganizationDomain,
                                                                userDetail.id,
                                                                projectInuseId,
                                                                {
                                                                    ...props,
                                                                    setIsLoading: () => {},
                                                                    API: props?.API,
                                                                    setIsOpenAccessDeniedPopup: (isOpen) => setIsOpenAccessDeniedPopup(isOpen),
                                                                    setIsOpenPopupKnowledgeOff: () => {},
                                                                    setIsOpenNotFoundTicketPopup: () => {},
                                                                    addNewPanel,
                                                                    setLastUserAction: () => {},
                                                                    setPanelList: () => {},
                                                                    setProjectDetail: () => {},
                                                                    userDetail: userDetail,
                                                                    setUserDetail: () => {},
                                                                    setShowPopupSingleButtonError: () => {},
                                                                },
                                                                withMessage
                                                            );
                                                            
                                                            document.body.style.cursor = 'default';
                                                        } catch (error) {
                                                            document.body.style.cursor = 'default';
                                                            console.error('Error opening share link:', error);
                                                        }
                                                    };

                                                    return (
                                                        <Chip
                                                            key={key}
                                                            label={
                                                                <div 
                                                                    onClick={(e) => handleClickShareLink(e)}
                                                                    onMouseDown={(e) => e.stopPropagation()}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        color: '#1976d2',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '4px',
                                                                        maxWidth: shouldHideTagDropdownIcon
                                                                            ? '600px'
                                                                            : '450px',
                                                                        width: '100%',
                                                                        pointerEvents: 'auto'
                                                                    }}
                                                                >
                                                                    <OverflowTooltipContent text={chipLabel} style={{ flex: 1 }} />
                                                                </div>
                                                            }
                                                            {...tagProps}
                                                            onClick={(e) => handleClickShareLink(e)}
                                                            onDelete={isDisableField ? null : tagProps.onDelete}
                                                            disabled={false}
                                                            clickable
                                                        />
                                                    )
                                                }

                                                if (isDisableField) {
                                                    return (
                                                        <DisabledChipWithTooltip
                                                            key={key}
                                                            label={chipLabel}
                                                            tagProps={tagProps}
                                                        />
                                                    );
                                                }

                                                return (
                                                    <Chip
                                                        key={key}
                                                        label={
                                                            <OverFlowTooltipWithTabsMui
                                                                value={chipLabel}
                                                            />
                                                        }
                                                        {...tagProps}
                                                        onDelete={tagProps.onDelete}
                                                    />
                                                );
                                            });
                                        }}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                error={validateError?.isError}
                                                variant="outlined"
                                                className="form-control form-control--wrapSelect form-control--hg40"
                                                onKeyDown={event => {
                                                    if (event.key === 'Backspace') event.stopPropagation();
                                                }}
                                            />
                                        )}
                                        renderOption={option => (
                                            <OverFlowTooltipWithTabsMui value={getDisplayTitle(option) || ''} />
                                        )}
                                    />
                              </div>
                            </>
                        }
                        {validateError?.isError && Utils.isEmptyString(getError(props.errorlist, props.name)) && (
                            <>
                                <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                    {validateError.message}
                                </p>
                            </>
                        )}
                        {getError(props.errorlist, props.name) &&
                            <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                {getError(props.errorlist, props.name)}
                            </p>
                        }

                        {showAddItemInput &&
                            props.data.structure.publicForCustomer == 3 &&
                            (enableShowMore ||
                                props.data.structure.optionType ===
                                    Constant.TAG_FIELD_OPTION_TYPE.SELECT) && (
                                <div className="form-addItem-input">
                                    <TextField
                                        {...errorsAddItem}
                                        className="form-control addItem-text-input form-control-wrapInput form-control-hg40"
                                        variant="outlined"
                                        onChange={onChangeAddItem}
                                        onKeyPress={handleOnKeyPressAddItem}
                                        error={!Utils.isEmptyString(errorsAddItem)}
                                    ></TextField>
                                    {!Utils.isEmptyString(errorsAddItem) && (
                                        <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                            {errorsAddItem}
                                        </p>
                                    )}
                                </div>
                            )}
                    </div>
                    <div className="tag-field-control">
                        {showAddItemInput &&
                            props.data.structure.publicForCustomer == 3 &&
                            !(
                                enableShowMore ||
                                props.data.structure.optionType ===
                                    Constant.TAG_FIELD_OPTION_TYPE.SELECT
                            ) && (
                                <div className="form-addItem-input">
                                    <TextField
                                        {...errorsAddItem}
                                        className="form-control addItem-text-input form-control-wrapInput form-control-hg40"
                                        variant="outlined"
                                        onChange={onChangeAddItem}
                                        onKeyPress={handleOnKeyPressAddItem}
                                        error={!Utils.isEmptyString(errorsAddItem)}
                                    ></TextField>
                                    {!Utils.isEmptyString(errorsAddItem) && (
                                        <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error add-item-error">
                                            {errorsAddItem}
                                        </p>
                                    )}
                                </div>
                            )}
                        {!enableShowMore &&
                            props.data.structure.publicForCustomer !== 2 &&
                            props.data.structure.optionType !==
                                Constant.TAG_FIELD_OPTION_TYPE.SELECT && tagList.length > numOfRecordDisplay &&(
                                <Box
                                    className={
                                        Utils.isEmptyString(props.detailTicket?.deletedAt)
                                            ? 'show-more-button link-file-name'
                                            : 'disable-show-more-button'
                                    }
                                    onClick={e =>
                                        Utils.isEmptyString(props.detailTicket?.deletedAt)
                                            ? enableShowMoreTagList()
                                            : e.preventDefault()
                                    }
                                    data-cy="render-field-tag-seemore"
                                >
                                    {tr('もっと見る')}
                                </Box>
                            )}
                    </div>
                </div>
            </div>
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={trI18n('KNOWDEMSG005')}
                okCallBack={e => {
                    setIsOpenAccessDeniedPopup(false);
                    window.location.reload();
                }}
                textSubmit={trI18n('CM-BUTTON-OK')}
            />
        </>
    );
}
